/* eslint-disable react/destructuring-assignment */
/* eslint-disable import/no-cycle */
/* eslint-disable-next-line max-classes-per-file */
import { EpisodeStorePublicInterface } from '@dorian/creation-tools-ui';
import async from 'async';
import classNames from 'classnames/bind';
import { cloneDeep, isEqual, isEmpty } from 'lodash-es';
import React, { Component, createRef, PureComponent } from 'react';
import {
  Alert, Badge, Card, Form, Spinner,
} from 'react-bootstrap';
import ReactDOM from 'react-dom';
import { DraggableCore } from 'react-draggable';
import { Redirect } from 'react-router-dom';
import IconCursor from '../../../assets/images/flag.png';
import {
  AchievementsContextProvider,
} from '../../../contexts/AchievementsContext/AchievementsContext';
import {
  HubTagTemplatesContextProvider,
} from '../../../contexts/HubTagTemplatesContext/HubTagTemplatesContext';
import { CursorProvider } from '../../../contexts/Cursor/CursorContext';
import { CursorNavigateConnector } from '../../../contexts/Cursor/CursorNavigateConnector';
import { CursorScrollFollower } from '../../../contexts/Cursor/CursorScrollFollower';
import { createDeferredCursorNavigate } from '../../../contexts/Cursor/deferredCursorNavigate';
import {
  PerformanceRanksContextProvider,
} from '../../../contexts/PerformanceRanksContext/PerformanceRanksContext';
import { SendNotificationsFor } from '../../../dorian-shared/types/book/book';
import { MEMORY_TECHNICAL_STEP_TYPES, StepTypes } from '../../../dorian-shared/types/branch/BranchStep';
import { EpisodeRunners } from '../../../dorian-shared/types/story/Story';
import { EpisodeValidationAction } from '../../../dorian-shared/types/validation/episodeValidation';
import { IS_MAC } from '../../../helpers/os';
import { UndoRedo } from '../../../helpers/UndoRedo';
import { bugTracker } from '../../../services/bugTracker/BugTrackerService';
import { logger } from '../../../services/loggerService/loggerService';
import { api } from '../../api';
import { PageWrapper } from '../../ui/PageWrapper';
import { showToast } from '../../ui/utils';
import { isDecisionStep } from '../../utils/branchUtils';
import { PremiumIpDisabledApprovedEdit } from '../../utils/premiumIpDisabledApprovedEdit';
import { PremiumIpDisabledEdit } from '../../utils/premiumIpDisabledEdit';
import {
  isAchievementsEnabled,
  isAudiosEnabled,
  isVideosEnabled,
  isMemoryBankEnabled,
} from '../../utils/userActionUtils';
import { AchievementsModal } from '../AchievementsModal/AchievementsModal';
import { HubTagTemplatesModal } from '../HubTagTemplatesModal/HubTagTemplatesModal';
import {
  AudiosProvider,
} from '../AudioLibraryPage/AudioLibraryContainer/AudiosProvider/AudiosProvider';
import { stopAllAudio, allowAudio } from '../AudioStepSettingsModal/AudioPlay/AudioController';
import { BookCover } from '../Book/BookCover';
import { ChapterRestoreModal } from '../Book/ChapterRestoreModal';
import { MemoryBankModal } from '../Book/MemoryBank/MemoryBankModal';
import { getMemoryBankSlotDataById } from '../Book/MemoryBank/memoryBankUtils';
import { Characters } from '../Characters';
import { ExportTextModal } from '../ExportTextModal/ExportTextModal';
import { ImportTextModal } from '../ImportTextModal/ImportTextModal';
import { Locations } from '../Locations';
import { PerformanceRanksModal } from '../PerformanceRanksModal/PerformanceRanksModal';
import { SelectiveEditModal } from '../SelectiveEditModal/SelectiveEditModal';
import { Export } from '../Stories/Export';
import {
  VideosProvider,
} from '../VideoLibraryPage/VideoLibraryContainer/VideosProvider/VideosProvider';
import { BookTagsModal } from './BookTagsModal';
import { fetchIsStoryAnalyticsVisible } from './BranchAnalytics/utils';
import { AddBranchContextWrapper } from './BranchEdit/AddBranchContextWrapper';
import { SidePanelAnnouncement } from './SidePanelAnnouncement/SidePanelAnnouncement';
import { clearStepData } from './BranchEdit/Steps/CopyPastStep';
import { isCheckStep } from './BranchEdit/Steps/StepTypeCheck/StepTypeCheck';
import { BranchItem } from './BranchItem';
import { BranchItemBadge } from './BranchItemBadge/BranchItemBadge';
import { CancelAddBranch } from './CancelAddBranch';
import { CoverEditor } from './CoverEditor';
import { DetachablePreview } from './DetachablePreview/DetachablePreview';
import { HelpSection } from './HelpSection';
import { CLIPBOARD_TYPE } from './CopyPaste/types';
import { writeClipboard, readClipboard, isSameBook } from './CopyPaste/clipboardUtils';

import { InfoPanel } from './InfoPanel';
import { NodePositioningModal } from './NodePositioningModal';
import { NotFoundModal } from './NotFoundModal';
import { BranchesListPanel } from './Panel/BranchesListPanel';
import { PublishModal, PublishType } from './PublishModal/PublishModal';
import { RenPyGameSettings } from './RenPyGameSettings/RenPyGameSettings';
import { SaveAsTemplate } from './SaveAsTemplate';
import { createSelectable, SelectableGroup } from './Selectable';
import { SharedSettingsPanel } from './SharedSettingsPanel';
import { ShareEmulatorLinkModal } from './ShareEmulatorLinkModal/ShareEmulatorLinkModal';
import styles from './StoryBranches.scss';
import './NodeEditSidePanel.scss';
import { ValidatePanel } from './ValidatePanel';

import { getClassNameByLineType, collectBranchEdges, collectCascadeIds } from './branchLines';
import { buildInboundIndex, getLinksTo, getLinksFrom } from './branchGraphHelpers';
import { FEATURE_NODE_EDIT_SIDE_PANEL } from '../../../helpers/featureFlags';

const USE_DELTA_BRANCH_FETCH = true;
const VIRTUALIZE_BRANCH_THRESHOLD = 30;
const VIEWPORT_BUFFER_PX = 400;

function isBranchInViewport(branch, scrollViewport, handleSize, buffer) {
  if (!scrollViewport) return true;
  const {
    contentLeft, contentTop, contentRight, contentBottom,
  } = scrollViewport;
  const left = contentLeft - buffer;
  const top = contentTop - buffer;
  const right = contentRight + buffer;
  const bottom = contentBottom + buffer;
  const branchRight = (branch.x ?? 0) + handleSize.x;
  const branchBottom = (branch.y ?? 0) + handleSize.y;
  return !((branch.x ?? 0) > right || branchRight < left || (branch.y ?? 0) > bottom || branchBottom < top);
}

const cs = classNames.bind(styles);

function SComponent(props) {
  const {
    children,
    selectableRef,
    isSelecting,
    selectionItems,
    selectableId,
  } = props;
  const isNodeSelected = selectionItems.includes(selectableId);

  return (
    <div
      ref={selectableRef}
      className={`
      ${isSelecting && 'selecting'}
      ${isNodeSelected && 'selected'}
    `}
    >
      {children}
    </div>
  );
}

const SelectableComponent = createSelectable(SComponent);

class BranchesLine extends PureComponent {
  render() {
    const {
      angle,
      top,
      left,
      toID,
      length,
      fromID,
      type,
      currentNodeClass,
    } = this.props;

    const style = {
      position: 'absolute',
      left: `${left}px`,
      top: `${top}px`,
      width: `${length}px`,
      transform: `rotate(${angle}deg)`,
      transformOrigin: '0 0',
    };

    const className = getClassNameByLineType(type);
    return (
      <div style={style} className={`line_${fromID}_${toID} ${className} ${currentNodeClass || ''}`} />
    );
  }
}

function isLiveEditDisabled(role, group) {
  if (!role) return true;

  return ['live', 'liveprompt'].includes(group);
}

function showDangerAlert(text, timeBeforeDisappearing = 1000) {
  ReactDOM.render(
    <Alert variant="danger" className="mx-3 my-3">
      {text}
    </Alert>,
    document.getElementById('errorsBox'),
  );
  setTimeout(() => {
    ReactDOM.render(null, document.getElementById('errorsBox'));
  }, timeBeforeDisappearing);
}

const handlePreviewExit = (reason) => {
  switch (reason) {
    case 'pass-to-publish-dialog':
      // TODO: publish
      return;
    default:
      // TODO: https://dorian.atlassian.net/browse/DOR-3171
      showDangerAlert('Thanks for playing');
  }
};

class StoryBranchesDorian extends Component {
  constructor(props) {
    super(props);
    const { auth } = this.props;

    // Read the last-visited branchId from localStorage so CursorProvider starts at the
    // real node. Without this, initialCursor.branchId=0 causes the first NAVIGATE(0→intro)
    // to push a {branchId:0} phantom entry into historyBack, making the Back button appear
    // active on fresh page load. If the stored value is missing or invalid, 0 is fine as
    // a fallback — the first real NAVIGATE will still push a phantom, but that's the
    // existing behaviour (no regression) and only occurs when localStorage has no history.
    const _episodeId = this.props.match?.params?.id ?? null;
    const _storedLastEdit = _episodeId
      ? JSON.parse(localStorage.getItem(`lastEdit-${_episodeId}`) ?? 'null')
      : null;
    this._initialCursorBranchId = (typeof _storedLastEdit === 'number' && _storedLastEdit > 0)
      ? _storedLastEdit
      : 0;

    const willPreviewPanelOpenedFromStorage = sessionStorage.getItem('previewPanelSate');
    const previewPanelState = willPreviewPanelOpenedFromStorage
      ? JSON.parse(willPreviewPanelOpenedFromStorage)
      : true;

    const hideCardDetailsRaw = localStorage.getItem('experimentalHideCardDetails');
    const hideCardDetails = hideCardDetailsRaw ? JSON.parse(hideCardDetailsRaw) : false;
    const dynamicBranchRenderingRaw = localStorage.getItem('experimentalDynamicBranchRendering');
    const dynamicBranchRendering = dynamicBranchRenderingRaw ? JSON.parse(dynamicBranchRenderingRaw) : true;
    // Drives only the switch's checked state for instant visual feedback. The actual
    // feature gate is the FEATURE_NODE_EDIT_SIDE_PANEL module constant, read once at
    // load; flipping the switch reloads the page so that constant is re-read.

    this.state = {
      stepTypes: [],
      branch: [],
      lastBranchesSyncTime: null,
      story: {},
      editBranchData: null,
      addBranchActive: false,
      showSidePanelAnnouncement: false,
      showLocations: false,
      branchesDragItems: [],
      branchesScale: localStorage.getItem('zoom') !== null ? JSON.parse(localStorage.getItem('zoom')) : 1,
      keyDownFlag: {},
      snapToGrid: true,
      showGrid: true,
      lastEdit: null,
      notFound: false,
      modeEdit: false,
      modeAdminStyle: 'd-none',
      modeEditStyle: 'd-none',
      validatePanel: false,
      lastLocation: null,
      branchesWrapper: { x: 5000, y: 5000 },
      handleSize: { x: 200, y: 160 },
      boxSize: { x: 25, y: 25 },
      grid: 25,
      infoPanel: false,
      branchesListPanel: false,
      dragStart: false,
      limits: {},
      newBranchId: null,
      newStories: null,
      selectionItems: [],
      savePositionLoading: false,
      warning: 0,
      error: 0,
      sharedSettingsPanel: false,
      preview: previewPanelState,
      showImagePath: false,
      authUser: auth.getUser(),
      branchOnNameEdit: false,
      NodePositioningModal: false,
      previewPanel: previewPanelState,
      destinationNodeId: null,
      sourceNodeId: null,
      sourceNodeIdType: null,
      shareModal: false,
      GoLiveLoading: false,
      GoLiveModal: false,
      saveTemplateModal: false,
      editCoverActive: false,
      ConfirmationCancelAddBranch: false,
      AddBranchEdit: false,
      showEditBookTags: false,
      isDuplicateMode: false,
      lastPastedBranchIds: [],
      showBookCover: false,
      showChapterRestore: false,
      HelpPanel: false,
      redirect: null,
      isAnalyticsVisible: false,
      scrollToNode: false,
      storePublicInterface: new EpisodeStorePublicInterface(FEATURE_NODE_EDIT_SIDE_PANEL),
      showMemoryBank: false,
      showAchievementsModal: false,
      showHubTagTemplatesModal: false,
      showImportTextModal: false,
      showExportTextModal: false,
      showSelectiveEditModal: false,
      // Remove this after refactoring
      reFetchMemoriesTrigger: 0,
      showPerformanceRanksModal: false,
      triggerRefresh: 0,
      scrollViewport: null,
      experimentalHideCardDetails: hideCardDetails,
      experimentalDynamicBranchRendering: dynamicBranchRendering,
      experimentalNodeEditSidePanel: FEATURE_NODE_EDIT_SIDE_PANEL,
      // Static type lists loaded once on mount — shared across all AddBranch opens.
      // AddBranch used to fetch these per-node; lifting here removes N redundant requests.
      answerTypes: [],
      modifierTypes: [],
      requiresTypes: [],
      traitsTypes: [],
      // Tracks cursor.branchId for Show this node in controlled mode (DEV-RULES §4).
      // Updated via CursorScrollFollower.onBranchIdChange callback.
      cursorBranchId: null,
      // Non-null while CancelAddBranch is shown for a goto-driven node switch.
      // Confirm action = revalidateAndOpenBranch(pendingGotoNode); cancel = dismiss only.
      pendingGotoNode: null,
      // Non-null while a save-and-continue is in flight: handleBranchUpdate navigates
      // to this node instead of closing the form when save completes.
      saveAndContinueTarget: null,
    };
    this.optionsRef = createRef();
    this.selectionRef = createRef();
    this.mainContent = createRef();
    this.mainContentWrapper = createRef();
    this.undoRedoBranchPosition = null;
    this.scrollInterval = null;
    this._scrollListenerAttached = false;
    this._scrollRafId = null;
    // Race-guard: id of the most recently requested branch open (revalidateAndOpenBranch).
    // If a newer open request arrives before an older one resolves, the older one bails out.
    this._pendingOpenBranchId = null;
    this._deferredNavigate = createDeferredCursorNavigate();
    this._resetCursorHistory = null;
    this._triggerFormSave = null;

    allowAudio(previewPanelState);
  }

  _scrollViewport = null;
  _lastViewportTile = null;

  updateScrollViewport = () => {
    const scrollEl = this.mainContent.current;
    const wrapperEl = this.mainContentWrapper.current;
    if (!scrollEl || !wrapperEl) return;
    const scale = Math.max(0.25, this._getCurrentScale());
    const scrollRect = scrollEl.getBoundingClientRect();
    const wrapperRect = wrapperEl.getBoundingClientRect();
    const visibleLeft = Math.max(scrollRect.left, wrapperRect.left);
    const visibleRight = Math.min(scrollRect.right, wrapperRect.right);
    const visibleTop = Math.max(scrollRect.top, wrapperRect.top);
    const visibleBottom = Math.min(scrollRect.bottom, wrapperRect.bottom);
    const contentLeft = (visibleLeft - wrapperRect.left) / scale;
    const contentTop = (visibleTop - wrapperRect.top) / scale;
    const contentRight = (visibleRight - wrapperRect.left) / scale;
    const contentBottom = (visibleBottom - wrapperRect.top) / scale;

    this._scrollViewport = {
      contentLeft, contentTop, contentRight, contentBottom,
    };

    // Only trigger re-render when scroll crosses a tile boundary.
    // Tile size = half the buffer, so nodes enter/leave the buffered zone
    // approximately every tile step. This avoids setState on every scroll frame.
    const tileSize = VIEWPORT_BUFFER_PX / 2;
    const tileKey = `${Math.floor(contentLeft / tileSize)},${Math.floor(contentTop / tileSize)},${Math.floor(contentRight / tileSize)},${Math.floor(contentBottom / tileSize)}`;
    if (tileKey !== this._lastViewportTile) {
      this._lastViewportTile = tileKey;
      this.setState({ scrollViewport: this._scrollViewport });
    }
  };

  handleScroll = () => {
    // Skip scroll-triggered viewport updates during active zoom —
    // zoomToPoint sets scroll programmatically and we don't want to
    // trigger setState/re-render while zooming
    if (this._currentScale !== null) return;
    if (this._scrollRafId != null) return;
    this._scrollRafId = requestAnimationFrame(() => {
      this._scrollRafId = null;
      this.updateScrollViewport();
    });
  };

  reRenderPreviewBranch = () => {
    // In controlled mode the emulator re-renders automatically: branch list updates
    // produce a new nodeGetter reference, which triggers the renderState subscriber
    // and delivers a fresh frame without any imperative push here.
    if (FEATURE_NODE_EDIT_SIDE_PANEL) {
      return;
    }
    const { storePublicInterface } = this.state;
    if (!storePublicInterface) {
      return;
    }
    storePublicInterface.internalStore.setNavHistoryStack([...storePublicInterface.internalStore.navHistoryStack]);
  };

  handleCursorNavigateReady = (navigate) => {
    this._deferredNavigate.setNavigate(navigate);
  };

  handleCursorResetReady = (reset) => {
    this._resetCursorHistory = reset;
  };

  handleSaveTriggerReady = (triggerSave) => {
    this._triggerFormSave = triggerSave;
  };

  handleCursorBranchIdChange = (branchId) => {
    this.setState({ cursorBranchId: branchId });
  };

  updatePreviewCurrentBranch = (branchId) => {
    if (FEATURE_NODE_EDIT_SIDE_PANEL) {
      const { branch: branches, storePublicInterface, reFetchMemoriesTrigger } = this.state;
      const branchById = branches.find((b) => b.id === branchId);
      const isIntro = !branchById || branchById.title === 'intro';
      if (storePublicInterface && isIntro) {
        storePublicInterface.setStackStartBranch(branchId);
        this.setState({ reFetchMemoriesTrigger: reFetchMemoriesTrigger + 1 });
      }
      // steps_count is always present; steps?: BranchStep[] is optional in delta payloads.
      const stepsCount = branchById?.steps_count ?? 0;
      // Pass undefined for stepIndex on same-node so NAVIGATE is a no-op in the reducer
      // (preserves cursor.stepIndex when the author clicks a node they are already viewing).
      // For different nodes: explicit null (empty node) or omit (default first step, index 0).
      const stepIndex = stepsCount > 0 ? undefined : null;
      this._deferredNavigate.invoke(branchId, stepIndex);
      // Reset AFTER navigate: cross-node NAVIGATE pushes the old cursor onto historyBack,
      // so clearing the cursor history must follow it to leave the back-arrow inactive on
      // the first intro click (intro is the story start — there is nowhere to go back to).
      if (isIntro) {
        this._resetCursorHistory?.();
      }
      return;
    }
    const {
      branch: branches,
      storePublicInterface,
      reFetchMemoriesTrigger,
    } = this.state;
    const branchById = branches.find((branch) => branch.id === branchId);

    if (!storePublicInterface) {
      return;
    }

    // with disabled caching for engine this will trigger refetch of data on CT side
    if (!branchById || branchById.title === 'intro') {
      storePublicInterface.setStackStartBranch(branchId);
      this.setState({ reFetchMemoriesTrigger: reFetchMemoriesTrigger + 1 });
      return;
    }

    if (!storePublicInterface.internalStore.isLoading) {
      storePublicInterface.internalStore.goAheadWithStory(branchId);
    } else {
      // TODO: Use smt tanStack Query or retry libraries
      let attempts = 0;
      const interval = setInterval(() => {
        if (!storePublicInterface.internalStore.isLoading) {
          clearInterval(interval);
          storePublicInterface.internalStore.goAheadWithStory(branchId);
        }
        if (attempts > 30) {
          clearInterval(interval);
        }
        attempts += 1;
      }, 500);
    }
  };

  updatePreviewAllBranches = () => {
    const {
      story,
      storePublicInterface,
    } = this.state;

    if (!storePublicInterface) {
      return;
    }

    const storyUuid = story.internal_uuid;
    api.get(`/v1/preview/${storyUuid}/branches`)
      .then((response) => {
        storePublicInterface.updateEpisodeBranches(response.data.branches);
        this.reRenderPreviewBranch();
      });
  };

  refreshPreviewBackgrounds = () => {
    const { story, storePublicInterface } = this.state;
    if (!storePublicInterface) {
      return;
    }

    const storyUuid = story.internal_uuid;
    api.get(`/v1/backgrounds/urls?uuid=${storyUuid}`)
      .then((response) => {
        storePublicInterface.updateBackgrounds(response.data.images);
      });
  };

  handleBranchDelete = () => {
    const { branch } = this.state;
    const firstBranchId = branch[0].id;
    this.updateBranch();
    this.updatePreviewCurrentBranch(firstBranchId);
  };

  handleSelectionFinish = (newSelectedNodes, clickedItem) => {
    if (FEATURE_NODE_EDIT_SIDE_PANEL && clickedItem?.id) {
      this.updatePreviewCurrentBranch(clickedItem.id);
    }

    if (newSelectedNodes.length === 0) {
      return;
    }

    const newSelectedNodeIds = newSelectedNodes.map((node) => node.id);
    this.setState({ selectionItems: newSelectedNodeIds });
  };

  handleSelectionClear = (selectItems = []) => {
    this.setSelectionItems(selectItems);
  };

  handleOnError = (error) => {
    bugTracker()
      .reportError(error);
    showToast({ textMessage: 'Error while trying to perform action' });
  };

  isElementContainsMainContentWrapperElement = (element) => this.mainContentWrapper.current?.hasChildNodes(element);

  // Current scale tracked outside state for synchronous DOM updates during zoom.
  // Synced back to state via debounced setState.
  _currentScale = null;
  _zoomSyncTimer = null;

  _getCurrentScale = () => (this._currentScale !== null ? this._currentScale : this.state.branchesScale);

  zoomToPoint = (newScale, pointX, pointY) => {
    const currentScale = this._getCurrentScale();
    if (newScale === currentScale) return;

    const container = this.mainContent.current;
    const wrapper = this.mainContentWrapper.current;
    if (!container || !wrapper) return;

    // World-space coordinates under cursor
    const worldX = (container.scrollLeft + pointX) / currentScale;
    const worldY = (container.scrollTop + pointY) / currentScale;

    // With transform-origin: 0 0, the point (worldX, worldY) in world space
    // maps to (worldX * scale, worldY * scale) in scroll space.
    // We want that point to stay at (pointX, pointY) in the viewport.
    // So: scrollLeft = worldX * newScale - pointX
    const targetScrollLeft = worldX * newScale - pointX;
    const targetScrollTop = worldY * newScale - pointY;

    // Update DOM synchronously — bypass React render to avoid async gaps
    this._currentScale = newScale;
    wrapper.style.transform = `scale(${newScale})`;
    wrapper.style.setProperty('--scale', newScale);

    // Set scroll with smooth behavior disabled
    container.style.scrollBehavior = 'auto';
    container.scrollLeft = targetScrollLeft;
    container.scrollTop = targetScrollTop;
    container.style.scrollBehavior = '';

    // Debounce React state sync — long delay to avoid re-rendering
    // 2200+ nodes during active pinch gesture. Only sync after zoom stops.
    clearTimeout(this._zoomSyncTimer);
    this._zoomSyncTimer = setTimeout(() => {
      this._currentScale = null;
      this.setState({ branchesScale: newScale });
    }, 500);
  };

  _animateZoomId = null;

  animateZoomToPoint = (targetScale, pointX, pointY) => {
    cancelAnimationFrame(this._animateZoomId);
    const duration = 200; // ms
    const startScale = this._getCurrentScale();
    const startTime = performance.now();

    const step = (now) => {
      const elapsed = now - startTime;
      const t = Math.min(elapsed / duration, 1);
      // ease-out quad
      const eased = t * (2 - t);
      const scale = parseFloat((startScale + (targetScale - startScale) * eased).toFixed(4));
      this.zoomToPoint(scale, pointX, pointY);
      if (t < 1) {
        this._animateZoomId = requestAnimationFrame(step);
      }
    };

    this._animateZoomId = requestAnimationFrame(step);
  };

  _pendingZoom = null;
  _zoomRafId = null;

  onWheel = (e) => {
    if (!this.isElementContainsMainContentWrapperElement(e.target)) return;

    if (!e.ctrlKey && !e.metaKey && !e.altKey) return;

    e.preventDefault();

    const currentScale = this._getCurrentScale();
    // Scale delta proportionally to pinch/scroll intensity.
    // Clamp abs(deltaY) to avoid huge jumps from fast trackpad gestures.
    const absDelta = Math.min(Math.abs(e.deltaY), 50);
    const delta = (e.deltaY > 0 ? -1 : 1) * absDelta * 0.007;
    const newScale = Math.max(0.25, Math.min(1, parseFloat((currentScale + delta).toFixed(4))));

    if (newScale === currentScale) return;

    const container = this.mainContent.current;
    const rect = container.getBoundingClientRect();

    // Store pending zoom, only execute once per animation frame
    this._pendingZoom = {
      newScale,
      mouseX: e.clientX - rect.left,
      mouseY: e.clientY - rect.top,
    };

    if (!this._zoomRafId) {
      this._zoomRafId = requestAnimationFrame(() => {
        this._zoomRafId = null;
        if (this._pendingZoom) {
          const { newScale: s, mouseX, mouseY } = this._pendingZoom;
          this._pendingZoom = null;
          this.zoomToPoint(s, mouseX, mouseY);
        }
      });
    }
  };

  onMouseDown = (e) => {
    const { keyDownFlag } = this.state;

    if (!this.isElementContainsMainContentWrapperElement(e.target)) {
      return;
    }

    /* e.button => 0 is left, 1 is middle, 2 is right */
    if (e.button === 2 || e.shiftKey && e.button === 0) {
      this.mainContent.current.addEventListener('mousemove', this.onMouseMove);
      const newKeyFlag = {
        ...keyDownFlag,
        Shift: true,
      };
      this.setState({ keyDownFlag: newKeyFlag });
    }
  };

  onMouseUp = (e) => {
    const { keyDownFlag } = this.state;

    this.mainContent.current?.removeEventListener('mousemove', this.onMouseMove);

    /* e.button => 0 is left, 1 is middle, 2 is right */
    if (e.button === 2 && keyDownFlag.Shift) {
      const newKeyFlag = {
        ...keyDownFlag,
        Shift: false,
      };
      this.setState({ keyDownFlag: newKeyFlag });
    }
  };

  onBlur = () => {
    this.setState({ keyDownFlag: {} });
  };

  onContextMenu = (e) => {
    if (this.isElementContainsMainContentWrapperElement(e.target)) {
      e.preventDefault();
    }
  };

  keyFunctionDown = (e) => {
    const {
      keyDownFlag: prevKeyDownFlag,
      savePositionLoading,
    } = this.state;

    const keyDownFlag = { ...prevKeyDownFlag };

    keyDownFlag.Shift = e.shiftKey;
    keyDownFlag.Control = e.ctrlKey;
    keyDownFlag.Meta = e.metaKey;
    keyDownFlag.Alt = e.altKey;

    const isInput = document.activeElement.nodeName === 'INPUT' || document.activeElement.nodeName === 'TEXTAREA' || document.activeElement.isContentEditable;
    if (isInput) {
      return;
    }

    const additionalKey = IS_MAC ? e.metaKey : e.ctrlKey;

    if (e.key.toLowerCase() === 'e' && additionalKey && !e.shiftKey) {
      e.preventDefault();
      const {
        showSelectiveEditModal,
        modeEdit,
      } = this.state;
      if (!savePositionLoading && modeEdit && !showSelectiveEditModal) {
        this.setState({ showSelectiveEditModal: true, selectiveEditInitialBranchId: null });
      }
      return;
    }

    // Alt+E (Option+E on Mac): open Selective Edit jumping to the selected node
    // Use e.code instead of e.key because macOS Option+E produces a dead key ('´')
    if (e.code === 'KeyE' && e.altKey && !e.shiftKey && !additionalKey) {
      e.preventDefault();
      const {
        showSelectiveEditModal,
        modeEdit,
        selectionItems,
      } = this.state;
      if (!savePositionLoading && modeEdit && !showSelectiveEditModal && selectionItems.length > 0) {
        this.setState({ showSelectiveEditModal: true, selectiveEditInitialBranchId: selectionItems[0] });
      }
      return;
    }

    if (e.key.toLowerCase() === 'z' && additionalKey) {
      e.preventDefault();
      if (this.undoRedoBranchPosition?.canUndo() && !savePositionLoading) {
        const nodes = this.undoRedoBranchPosition.getCurrentState()?.prev ?? [];
        this.undoRedoBranchPosition.undo();
        this.savePosition(nodes);

        const selectionItems = nodes.map((node) => node.id);
        this.setSelectionItems(selectionItems);
      }
      return;
    }

    if (e.key.toLowerCase() === 'y' && additionalKey) {
      e.preventDefault();
      if (this.undoRedoBranchPosition?.canRedo() && !savePositionLoading) {
        const nodes = this.undoRedoBranchPosition.redo()?.next ?? [];
        this.savePosition(nodes);

        const selectionItems = nodes.map((node) => node.id);
        this.setSelectionItems(selectionItems);
      }
      return;
    }

    if (e.key.toLowerCase() === 'c' && additionalKey) {
      const selection = window.getSelection();
      if (selection && selection.toString().length > 0) {
        return; // Let native copy handle selected text
      }
      e.preventDefault();
      this.handleCopy();
      return;
    }

    if (e.key.toLowerCase() === 'v' && additionalKey) {
      e.preventDefault();
      this.handlePasteIntent();
      return;
    }

    if (e.key === 'Escape') {
      const { isDuplicateMode } = this.state;
      if (isDuplicateMode) {
        this.setState({ isDuplicateMode: false });
      }
      return;
    }

    switch (e.key) {
      case 'Control':
        keyDownFlag[e.key] = true;
        this.setState({ keyDownFlag });
        break;
      case 'Alt':
        e.preventDefault();
        keyDownFlag[e.key] = true;
        this.setState({ keyDownFlag });
        break;
      case ' ':
        e.preventDefault();
        if (keyDownFlag.Shift) {
          return;
        }
        keyDownFlag.Shift = true;
        this.setState({ keyDownFlag });
        break;
      case 'Shift':
        keyDownFlag.Shift = true;
        this.setState({ keyDownFlag });
        break;
      case 'Command':
      case 'Meta':
        keyDownFlag.Meta = true;
        this.setState({ keyDownFlag });
        break;
      default:
        break;
    }
  };

  keyFunctionUp = (e) => {
    const { keyDownFlag: prevKeyDownFlag } = this.state;

    const keyDownFlag = { ...prevKeyDownFlag };

    keyDownFlag.Shift = e.shiftKey;
    keyDownFlag.Control = e.ctrlKey;
    keyDownFlag.Meta = e.metaKey;
    keyDownFlag.Alt = e.altKey;

    switch (e.key) {
      case 'Control':
        keyDownFlag[e.key] = false;
        this.setState({ keyDownFlag });
        break;
      case 'Alt':
        keyDownFlag[e.key] = false;
        e.preventDefault();
        this.setState({ keyDownFlag });
        break;
      case ' ':
      case 'Shift':
        keyDownFlag[e.key] = false;
        this.setState({ keyDownFlag });
        break;
      case 'Command':
      case 'Meta':
        keyDownFlag.Meta = false;
        this.setState({ keyDownFlag });
        break;
      default:
        break;
    }
  };

  errCount = (warning, error) => {
    this.setState({
      warning,
      error,
    });
  };

  scrollToBranch = (branchId, force = false) => {
    const {
      branchesScale,
      lastEdit,
      scrollToNode,
    } = this.state;

    if (lastEdit === branchId && !force) {
      return;
    }
    this.setState({ lastEdit: branchId });

    if (!scrollToNode && !force) {
      return;
    }

    const elm = document.getElementById(`branches_${branchId}`);
    if (elm) {
      const elmTop = (elm.offsetTop - 30) * branchesScale;
      const elmLeft = (elm.offsetLeft - 30) * branchesScale;
      this.mainContent.current?.scrollTo(elmLeft, elmTop);
    }
  };

  validateAction = (branch, key) => {
    const {
      validatePanel,
      branch: branchFromState,
      infoPanel,
    } = this.state;

    this.setState({
      lastEdit: branch || null,
    });

    if (branch) {
      this.scrollToBranch(branch, true);
    }

    if (key) {
      if (key === 'story') {
        this.setState({
          validatePanel: !validatePanel,
        }, () => {
          if (this.optionsRef.current) {
            this.optionsRef.current.show?.();
          }
        });
      }

      if (key === 'info') {
        this.setState({
          validatePanel: !validatePanel,
          infoPanel: !infoPanel,
        });
      }

      if (key === 'book_cover') {
        this.setState({
          validatePanel: !validatePanel,
        }, () => {
          this.actionBookCover();
        });
      }

      if (key === 'story_cover') {
        this.setState({
          validatePanel: !validatePanel,
        }, () => {
          this.actionEditCover();
        });
      }

      if (key === 'locations') {
        this.setState({
          validatePanel: !validatePanel,
        });
        this.initLocations();
        return;
      }

      if (key === 'branches') {
        //don't close validation panel
        const b = branchFromState.find((e) => e.id === branch);
        this.revalidateAndOpenBranch(b);
      }
      if (key === 'characters') {
        this.actionEditCharacters();
      }
      if (key === 'book_tags') {
        this.setState({
          validatePanel: !validatePanel,
        }, () => {
          this.setState({
            showEditBookTags: true,
          });
        });
      }

      if (key === EpisodeValidationAction.StoryMustHaveLiveAchievement) {
        this.setState({
          validatePanel: !validatePanel,
        }, () => {
          this.setState({
            showAchievementsModal: true,
          });
        });
      }
    }
  };

  clearSelectionUsingRef = () => {
    this.selectionRef.current?.clearSelection();
  };

  componentDidMount() {
    const { story } = this.state;

    clearStepData();
    this.attachScrollListenerIfNeeded();
    this.loadSettings();
    this.loadBranchList();
    this.loadStory();
    document.addEventListener('blur', this.onBlur);
    document.addEventListener('visibilitychange', this.onBlur);
    document.addEventListener('contextmenu', this.onContextMenu, { passive: false });
    document.addEventListener('wheel', this.onWheel, { passive: false });
    document.addEventListener('mousedown', this.onMouseDown, { passive: false });
    document.addEventListener('mouseup', this.onMouseUp, { passive: false });
    document.addEventListener('keydown', this.keyFunctionDown, { passive: false });
    document.addEventListener('keyup', this.keyFunctionUp, { passive: false });
    window.addEventListener('storage', this.updateStorage, { passive: false });
    localStorage.removeItem(`modeEdit-${story.internal_uuid}`);
    this.newStorySteps();
  }

  newStorySteps() {
    const { match } = this.props;
    const { branch } = this.state;

    const a = JSON.parse(sessionStorage.getItem('newStories'));
    if (a && String(a.id) === String(match.params.id)) {
      this.setState({
        newStories: String(a.id),
      });
      switch (a.step) {
        case 1:
          this.initLocations();
          break;
        case 2:
          break;
        case 3:

          if (branch.length === 1) {
            this.revalidateAndOpenBranch(branch[0]);
          } else {
            sessionStorage.removeItem('newStories');
            this.setState({
              editBranchData: null,
              addBranchActive: false,
              newStories: null,
            });
          }
          break;
        default:
          sessionStorage.removeItem('newStories');
          break;
      }
    }
  }

  updateStorage = (e) => {
    if (e.key === 'newStories') {
      this.newStorySteps();
    }
  };

  mGrid() {
    const { branch: branches } = this.state;
    const newBranchesWrapper = {
      x: 0,
      y: 0,
    };
    branches.forEach((branch) => {
      newBranchesWrapper.x = Math.max(newBranchesWrapper.x, branch.x + 5000);
      newBranchesWrapper.y = Math.max(newBranchesWrapper.y, branch.y + 5000);
    });
    this.setState({ branchesWrapper: newBranchesWrapper });
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      auth,
      match,
      context,
    } = this.props;
    const {
      lastEdit,
      branch,
      authUser,
      story,
      keyDownFlag,
      branchesScale,
      preview,
      addBranchActive,
      reFetchMemoriesTrigger,
      cursorBranchId,
      editBranchData,
      AddBranchEdit,
    } = this.state;

    const {
      memoryBankContext,
      memoryIconsContext,
    } = context;

    if (prevState.lastEdit !== lastEdit && lastEdit) {
      localStorage.setItem(`lastEdit-${match.params.id}`, lastEdit);
    }

    if (prevState.branchesScale !== branchesScale) {
      localStorage.setItem('zoom', JSON.stringify(branchesScale));
      this.updateScrollViewport();
    }

    if (
      prevProps.auth !== auth
      || prevProps.auth.getUser().id !== auth.getUser().id
      || prevProps.auth.getUser().role !== auth.getUser().role
    ) {
      this.setState({ authUser: auth.getUser() });
    }

    if (prevState.branch !== branch) {
      this.mGrid();
    }

    this.attachScrollListenerIfNeeded();

    if (prevState.story.story_role !== story.story_role) {
      let modeEdit = true;
      let modeEditStyle = 'd-none';

      if (authUser.role !== 'admin' && story.story_role === 'viewer') {
        modeEdit = false;
        modeEditStyle = 'd-none';
      }

      if (authUser.role === 'admin' && story.story_role !== 'owner') {
        modeEdit = localStorage.getItem('modeEdit') !== null
          ? !JSON.parse(localStorage.getItem('modeEdit'))
          : false;
        modeEditStyle = 'd-block';
      }

      this.setState({
        modeEdit,
        modeEditStyle,
        modeAdminStyle: authUser.role === 'admin' ? 'd-block' : 'd-none',
      });

      localStorage.setItem(`modeEdit-${story.internal_uuid}`, !modeEdit);

      fetchIsStoryAnalyticsVisible(authUser, story.book.id, story.group)
        .then((isStoryAnalyticsVisible) => {
          this.setState({ isAnalyticsVisible: isStoryAnalyticsVisible });
        });
    }

    if (prevState.keyDownFlag.Shift !== keyDownFlag.Shift) {
      if (keyDownFlag.Shift) {
        this.mainContent.current?.setAttribute('style', 'cursor: grab');
        document.body.style.userSelect = 'none';
      } else {
        this.mainContent.current?.setAttribute('style', 'cursor: default');
        document.body.style.userSelect = 'auto';
      }
    }

    if (prevState.preview !== preview) {
      sessionStorage.setItem('previewPanelSate', preview);
    }

    if (prevState.story?.book?.id !== story?.book?.id) {
      memoryBankContext.setBookId(story?.book?.id);
      memoryIconsContext.setBookId(story?.book?.id);
    }

    if (!prevState.addBranchActive && addBranchActive) {
      if (!FEATURE_NODE_EDIT_SIDE_PANEL) {
        stopAllAudio();
        allowAudio(false);
      }
      // When the Node Edit panel opens in side-by-side mode, respect the author's
      // own emulator choice instead of forcing it visible: read previewPanelSate
      // and only show the emulator if the author had it open. When hidden, the
      // form goes full-width (see .nodeEditPanel--full in NodeEditSidePanel.scss).
      // (Typo 'Sate' in sessionStorage key is intentional — matches production.)
      if (FEATURE_NODE_EDIT_SIDE_PANEL) {
        const stored = sessionStorage.getItem('previewPanelSate');
        const initialPreview = stored !== null ? JSON.parse(stored) : true;
        this.setState({ preview: initialPreview, previewPanel: initialPreview });
        // First-run notice for the default-on rollout: show it the first time a
        // creator opens a node while they have never made an explicit choice
        // about the feature (the flag key is absent in localStorage). Dismissing
        // it writes the key, so it never returns. Informational only.
        if (localStorage.getItem('featureNodeEditSidePanel') === null) {
          this.setState({ showSidePanelAnnouncement: true });
        }
      }
    }
    if (prevState.addBranchActive && !addBranchActive) {
      allowAudio(preview);
      // Re-apply the author's emulator choice when the form closes in
      // side-by-side mode. Read directly from sessionStorage so state stays in
      // sync with the same source the open branch above reads.
      if (FEATURE_NODE_EDIT_SIDE_PANEL) {
        const stored = sessionStorage.getItem('previewPanelSate');
        const restoredPreview = stored !== null ? JSON.parse(stored) : true;
        // Restore both preview (show/hide) and previewPanel (CSS class for right:0)
        this.setState({ preview: restoredPreview, previewPanel: restoredPreview });
      }
    }

    if (
      FEATURE_NODE_EDIT_SIDE_PANEL
      && prevState.cursorBranchId !== cursorBranchId
      && addBranchActive
      && cursorBranchId != null
      && cursorBranchId !== editBranchData?.id
    ) {
      const targetNode = branch.find((b) => b.id === cursorBranchId) ?? null;
      if (targetNode !== null) {
        if (!AddBranchEdit) {
          this.revalidateAndOpenBranch(targetNode);
        } else {
          this.setState({ pendingGotoNode: targetNode, ConfirmationCancelAddBranch: true });
        }
      }
    }
  }

  attachScrollListenerIfNeeded = () => {
    if (this._scrollListenerAttached || !this.mainContent.current) return;
    this.mainContent.current.addEventListener('scroll', this.handleScroll, { passive: true });
    this._scrollListenerAttached = true;
    this.updateScrollViewport();
  };

  componentWillUnmount() {
    const { story } = this.state;
    if (this._scrollListenerAttached && this.mainContent.current) {
      this.mainContent.current.removeEventListener('scroll', this.handleScroll);
      this._scrollListenerAttached = false;
    }
    if (this._scrollRafId != null) {
      cancelAnimationFrame(this._scrollRafId);
    }
    document.removeEventListener('blur', this.onBlur);
    document.removeEventListener('visibilitychange', this.onBlur);
    document.removeEventListener('contextmenu', this.onContextMenu, false);
    document.removeEventListener('wheel', this.onWheel, false);
    document.removeEventListener('mousedown', this.onMouseDown, false);
    document.removeEventListener('mouseup', this.onMouseUp, false);
    document.removeEventListener('keydown', this.keyFunctionDown, false);
    document.removeEventListener('keyup', this.keyFunctionUp, false);
    window.removeEventListener('storage', this.updateStorage);
    localStorage.removeItem(`modeEdit-${story.internal_uuid}`);
    sessionStorage.removeItem('newStories');
  }

  updateGoLive = () => {
    const {
      validatePanel,
      story,
    } = this.state;
    this.setState({
      GoLiveLoading: true,
    });

    let url = `/v1/books/${story.book.id}/chapters/${story.id}/golive`;
    if (story.group === 'prompt') {
      url = `/v1/books/${story.book.id}/chapters/${story.id}/makepromptlive`;
    } else if (story.book.original) {
      url = `/v1/books/${story.book.id}/chapters/${story.id}/submit`;
    }

    api.post(url)
      .then(() => {
        this.setState({
          GoLiveModal: false,
          GoLiveLoading: false,
          redirect: `/book/${story.book.id}`,
        });
      })
      .catch((error) => {
        this.setState({
          GoLiveModal: false,
          GoLiveLoading: false,
          validatePanel: String(error.response.status) !== '418' ? validatePanel : true,
        }, () => {
          if (String(error.response.status) !== '418') {
            bugTracker()
              .reportError(error);
            showToast({ textMessage: 'Error while trying to go live' });
            console.error('Error while trying to go live:', error.response?.status, error.response?.data, error);
          }
        });
      });
  };

  loadSettings() {
    const { authUser } = this.state;

    async.parallel({
      settings: (callback) => {
        api.get('/v1/settings')
          .then((res) => {
            callback(null, res.data.settings);
          })
          .catch((error) => {
            callback(error, null);
          });
      },
      types: (callback) => {
        api.get('/v1/steps/types')
          .then((res) => {
            callback(null, res.data.types);
          })
          .catch((error) => {
            callback(error, null);
          });
      },
      answerTypes: (callback) => {
        api.get('/v1/answers/types')
          .then((res) => {
            callback(null, res.data.types);
          })
          .catch((error) => {
            callback(error, null);
          });
      },
      modifierTypes: (callback) => {
        api.get('/v1/answers/modifiers/types')
          .then((res) => {
            callback(null, res.data.types);
          })
          .catch((error) => {
            callback(error, null);
          });
      },
      stats: (callback) => {
        api.get('/v1/stats/types')
          .then((res) => {
            callback(null, res.data.types);
          })
          .catch((error) => {
            callback(error, null);
          });
      },
    }, (err, res) => {
      try {
        if (!err) {
          const allTypes = res.types.some((t) => t.id === StepTypes.Hub)
            ? res.types
            : [...res.types, { id: StepTypes.Hub, title: 'Hub', value: 'Hub', fields: ['hubOptions'] }];
          const stepTypes = isMemoryBankEnabled(authUser)
            ? allTypes
            : allTypes.filter((type) => !MEMORY_TECHNICAL_STEP_TYPES.includes(type.id));

          // Split stats into the two consumer shapes once, rather than on every node open.
          const requiresTypes = (res.stats ?? []).filter((item) => item.require === true);
          const traitsTypes = (res.stats ?? []).filter((item) => item.trait === true);

          this.setState({
            stepTypes,
            limits: res.settings.limits,
            showImagePath: res.settings.preferences.show_character_image_path.value === 'on',
            answerTypes: res.answerTypes ?? [],
            modifierTypes: res.modifierTypes ?? [],
            requiresTypes,
            traitsTypes,
          });
        }
      } catch (e) {
        // TODO: report to sentry
      }
    });
  }

  loadBranchList = async (NewBranchId, val) => {
    const {
      match,
      context,
    } = this.props;
    const { apiService } = context;

    this.setState({ savePositionLoading: true });
    try {
      const result = await apiService.fetchStoryBranchesByEpisodeId(match.params.id);
      const branches = result.branches;

      // eslint-disable-next-line max-len
      const newValID = val && val.id && val.arr && val.arr.number && val.arr.number === 1 ? val.id : null;
      const lastEditFromStorage = localStorage.getItem(`lastEdit-${match.params.id}`);
      const firstNode = branches[0]?.id ?? null;
      const prevLastEdit = JSON.parse(lastEditFromStorage ?? 'null');
      const isPrevNodeExist = branches.some((branch) => branch.id === prevLastEdit);
      const newLastEdit = isPrevNodeExist ? prevLastEdit : firstNode;

      if (!this.undoRedoBranchPosition) {
        this.undoRedoBranchPosition = new UndoRedo([[]]);
      }

      this.setState({
        newBranchId: newValID || null,
        branch: branches,
        destinationNodeId: null,
        sourceNodeId: null,
        sourceNodeIdType: null,
        lastEdit: newLastEdit,
        ...(result.serverTime != null && { lastBranchesSyncTime: result.serverTime }),
      });

      this.updatePreviewCurrentBranch(newLastEdit);

      if (val && val.arr && val.arr.number && val.arr.number !== 1) {
        const value = val.arr;
        value.number -= 1;
        this.initAddBranch(value);
      }
    } catch (error) {
      bugTracker()
        .reportError(error);
      showToast({ textMessage: 'Error while trying to load branches' });
    } finally {
      this.setState({ savePositionLoading: false });
    }
  };

  loadBranchListV2 = async (NewBranchId, val) => {
    const {
      match,
      context,
    } = this.props;
    const { apiService } = context;
    const storyId = match.params.id;

    this.setState({ savePositionLoading: true });
    try {
      const { lastBranchesSyncTime } = this.state;
      let branches;
      let newSyncTime;

      if (lastBranchesSyncTime) {
        const result = await apiService.fetchStoryBranchesChanges(storyId, lastBranchesSyncTime);
        newSyncTime = result.serverTime;
        if (result.full) {
          branches = result.branches;
        } else {
          const byId = {};
          this.state.branch.forEach((b) => { byId[b.id] = b; });
          result.branches.forEach((b) => { byId[b.id] = b; });
          const ids = Object.keys(byId).map(Number).sort((a, b) => a - b);
          branches = ids.map((id) => byId[id]);
        }
      } else {
        const result = await apiService.fetchStoryBranchesByEpisodeId(storyId);
        branches = result.branches;
        newSyncTime = result.serverTime;
      }

      // eslint-disable-next-line max-len
      const newValID = val && val.id && val.arr && val.arr.number && val.arr.number === 1 ? val.id : null;
      const lastEditFromStorage = localStorage.getItem(`lastEdit-${storyId}`);
      const firstNode = branches[0]?.id ?? null;
      const prevLastEdit = JSON.parse(lastEditFromStorage ?? 'null');
      const isPrevNodeExist = branches.some((branch) => branch.id === prevLastEdit);
      const newLastEdit = isPrevNodeExist ? prevLastEdit : firstNode;

      if (!this.undoRedoBranchPosition) {
        this.undoRedoBranchPosition = new UndoRedo([[]]);
      }

      this.setState({
        newBranchId: newValID || null,
        branch: branches,
        destinationNodeId: null,
        sourceNodeId: null,
        sourceNodeIdType: null,
        lastEdit: newLastEdit,
        ...(newSyncTime != null && { lastBranchesSyncTime: newSyncTime }),
      });

      this.updatePreviewCurrentBranch(newLastEdit);

      if (val && val.arr && val.arr.number && val.arr.number !== 1) {
        const value = val.arr;
        value.number -= 1;
        this.initAddBranch(value);
      }
    } catch (error) {
      bugTracker()
        .reportError(error);
      showToast({ textMessage: 'Error while trying to load branches' });
    } finally {
      this.setState({ savePositionLoading: false });
    }
  };

  loadStory() {
    const {
      match,
      context,
    } = this.props;
    const {
      memoryBankContext,
      bookLocationContext,
      bookCharactersContext,
    } = context;

    api.get(`/v1/stories/${match.params.id}`)
      .then((res) => {
        this.setState({
          story: res.data.story,
        });
        memoryBankContext.fetchMemories();
        bookLocationContext.fetchBookLocations(res.data.story.book.id);
        if (FEATURE_NODE_EDIT_SIDE_PANEL) {
          bookCharactersContext.fetchBookCharacters(res.data.story.book.id);
        }
      })
      .catch((error) => {
        bugTracker()
          .reportError(error);
        showToast({ textMessage: 'Error while trying to load story' });
      });

    // Character-skin id -> alias map, used to render character-memory CHECK
    // node previews with the skin alias instead of its raw numeric id (the
    // stored check value). Non-fatal: on failure the preview falls back to the
    // raw id.
    api.get(`/v1/stories/${match.params.id}/characters`)
      .then((res) => {
        const characterAliasesById = (res.data.characters || []).reduce((map, character) => {
          map[character.id] = character.alias;
          return map;
        }, {});
        this.setState({ characterAliasesById });
      })
      .catch((error) => {
        bugTracker().reportError(error);
      });
  }

  handleStart(event, data, nodeToMove) {
    const {
      branchesScale,
      selectionItems: selectionItemIds,
      branch: branches,
      savePositionLoading,
      lastEdit,
    } = this.state;

    if (savePositionLoading) {
      return;
    }

    const wrapBox = this.mainContentWrapper.current.getBoundingClientRect();
    const wrapBoxLeft = wrapBox ? wrapBox.left : 0;
    const wrapBoxTop = wrapBox ? wrapBox.top : 0;

    const isNodeToMoveExist = selectionItemIds.some((selectionItemId) => selectionItemId === nodeToMove.id);

    const nodesToMove = selectionItemIds.map((selectedNodeId) => branches.find((node) => node.id === selectedNodeId));

    const isCtrlPressed = event.ctrlKey || event.metaKey;

    if (isCtrlPressed) {
      return;
    }

    const newSelectionItems = isNodeToMoveExist ? selectionItemIds : [nodeToMove.id];

    if (!isEqual(newSelectionItems, selectionItemIds)) {
      this.setSelectionItems(newSelectionItems);
    }

    if (newSelectionItems.length === 1) {
      this.setState(
        { lastEdit: nodeToMove.id },
        () => {
          if (lastEdit !== nodeToMove.id) {
            this.updatePreviewCurrentBranch(nodeToMove.id);
          }
        },
      );
    }
    this.setState({
      dX: ((event.clientX - wrapBoxLeft) / branchesScale) - nodeToMove.x,
      dY: ((event.clientY - wrapBoxTop) / branchesScale) - nodeToMove.y,
      branchesDragItems: isNodeToMoveExist ? nodesToMove : [nodeToMove],
    });
    this.mainContent.current.addEventListener('mousemove', this.onMouseMove);
  }

  getSnapToGridPosition = (x, y) => {
    const { grid: cellSize } = this.state;

    const snapToGridX = Math.round(x / cellSize) * cellSize;
    const snapToGridY = Math.round(y / cellSize) * cellSize;
    return {
      x: snapToGridX,
      y: snapToGridY,
    };
  };

  calculateNodePosition(uiX, uiY, node, pickedNodeToMove) {
    const {
      branchesScale,
      dX,
      dY,
      snapToGrid,
    } = this.state;

    const dragNodeLeftPosition = (uiX / branchesScale) - dX;
    const dragNodeTopPosition = (uiY / branchesScale) - dY;
    const isCurrentDragNode = node.id === pickedNodeToMove.id;
    const offsetPositionX = isCurrentDragNode ? 0 : pickedNodeToMove.x - node.x;
    const offsetPositionY = isCurrentDragNode ? 0 : pickedNodeToMove.y - node.y;
    const preLeftPosition = dragNodeLeftPosition - offsetPositionX;
    const preTopPosition = dragNodeTopPosition - offsetPositionY;

    const x = preLeftPosition >= 0 ? preLeftPosition : 0;
    const y = preTopPosition >= 0 ? preTopPosition : 0;

    if (snapToGrid) {
      const snapToGridPosition = this.getSnapToGridPosition(x, y);
      return {
        x: snapToGridPosition.x,
        y: snapToGridPosition.y,
      };
    }

    return {
      x,
      y,
    };
  }

  handleDrag(event, data, nodeToMove) {
    const {
      branchesDragItems,
      dragStart,
      branch: branches,
      experimentalHideCardDetails,
    } = this.state;

    const isCtrlPressed = event.ctrlKey || event.metaKey;

    if (isCtrlPressed) {
      return;
    }

    // To prevent dragging if distance is less than 10px
    const position = this.calculateNodePosition(data.x, data.y, nodeToMove, nodeToMove);
    const distance = Math.abs(position.x - nodeToMove.x) + Math.abs(position.y - nodeToMove.y);
    if (distance < 10) {
      return;
    }

    if (!dragStart) {
      this.setState({ dragStart: true });
    }

    branchesDragItems.forEach((movingNode) => {
      if (movingNode.id) {
        const newPosition = this.calculateNodePosition(data.x, data.y, movingNode, nodeToMove);
        const dragNodeElement = document.getElementById(`branchesDragItem-${movingNode.id}`);
        dragNodeElement.setAttribute('style', `display: block; left: ${newPosition.x}px; top: ${newPosition.y}px;z-index:99999;`);
        dragNodeElement.classList.add('opacity');
      }
    });
  }

  handleStop(event, data, dragNode) {
    const {
      dragStart,
      branchesDragItems: movedNodes,
      branch: branches,
    } = this.state;
    this.mainContent.current?.removeEventListener('mousemove', this.onMouseMove);
    this.stopScroll();

    if (!dragStart) {
      return;
    }

    const movedNodesWithNewPosition = movedNodes.map(
      (branchesDragItem) => {
        const newPosition = this.calculateNodePosition(data.x, data.y, branchesDragItem, dragNode);
        return { ...branchesDragItem, ...newPosition };
      },
    );

    const filteredNodes = branches.filter((branch) => movedNodesWithNewPosition.some((node) => node.id === branch.id));

    const doQueue = {
      prev: cloneDeep(filteredNodes),
      next: movedNodesWithNewPosition,
    };

    this.undoRedoBranchPosition?.do(doQueue);
    this.savePosition(movedNodesWithNewPosition);

    this.setState({
      dragStart: false,
      branchesDragItems: [],
    });
  }

  moveDragNodesToSavedPosition(movedNodes) {
    const { branch: allNodes } = this.state;

    movedNodes.forEach(
      (movedNode) => {
        const nodeToMove = allNodes.find((node) => node.id === movedNode.id);
        // TODO: To think about refactoring
        nodeToMove.x = movedNode.x;
        nodeToMove.y = movedNode.y;

        const movedNodeElement = document.getElementById(`branches_${movedNode.id}`);
        if (movedNodeElement) {
          movedNodeElement.setAttribute('style', `position: absolute; left: ${movedNode.x}px; top: ${movedNode.y}px;`);
          movedNodeElement.classList.remove('opacity');
        }
      },
    );
    this.mGrid();
  }

  setSelectionItems = (selectionItems) => {
    this.clearSelectionUsingRef();
    this.selectionRef.current?.selectByIds(selectionItems);
    this.setState({ selectionItems });
  };

  savePosition(nodes) {
    const { match } = this.props;

    this.setState({ savePositionLoading: true });

    const prepareNodesForPayload = nodes.map(
      (node) => ({
        id: node.id,
        data: {
          x: node.x,
          y: node.y,
        },
      }),
    );

    const payload = {
      branches: prepareNodesForPayload,
    };

    this.moveDragNodesToSavedPosition(nodes);
    api.patch(`/v1/stories/${match.params.id}/branches`, payload)
      .then(() => {
        // TODO: update status
        logger.info('[StoryBranches] Branches position saved', payload);
      })
      .catch((error) => {
        showToast({ textMessage: `Branches position save failed${error.message}` });
        if (this.undoRedoBranchPosition?.canUndo()) {
          const restoredBranchPositions = this.undoRedoBranchPosition.getCurrentState()?.prev ?? [];
          this.undoRedoBranchPosition.undo();
          this.moveDragNodesToSavedPosition(restoredBranchPositions);

          const selectionItems = restoredBranchPositions.map((node) => node.id);
          this.setSelectionItems(selectionItems);
        }
      })
      .finally(() => this.setState({ savePositionLoading: false }));
  }

  addBranches = (val) => {
    const { branchesScale } = this.state;

    const value = {
      x: this.mainContent.current.scrollLeft / branchesScale,
      y: this.mainContent.current.scrollTop / branchesScale,
      number: val,
    };
    this.initAddBranch(value);
  };

  initAddBranch = (branchData) => {
    this.setState({
      editBranchData: branchData ?? null,
      addBranchActive: true,
    });
  };

  // Opens a branch node for editing with a lightweight delta revalidate before showing the form.
  // Flag OFF → immediate initAddBranch (zero change to existing behaviour).
  // Flag ON:
  //   1. Mark this open as the "pending" one (race guard: only the latest wins).
  //   2. fetchStoryBranchesChanges to refresh the client-side cache (delta, not full reload).
  //   3. Patch state.branch[] and lastBranchesSyncTime with the delta result.
  //   4. Pull the freshened node from state, attach computed links_from/links_to, open form.
  //   5. If revalidate fails → fallback to initAddBranch(branchData) with stale-but-ok data.
  // The revalidate latency is absorbed by the form's own loading spinner (7 ref-data requests
  // run in parallel while the user sees the spinner — no extra UI needed).
  revalidateAndOpenBranch = async (branchData) => {
    if (!FEATURE_NODE_EDIT_SIDE_PANEL) {
      this.initAddBranch(branchData);
      return;
    }

    if (!branchData || !branchData.id) {
      this.initAddBranch(branchData);
      return;
    }

    // Race guard: stamp this request; bail after await if a newer one arrived.
    this._pendingOpenBranchId = branchData.id;
    const requestedId = branchData.id;

    try {
      const { match, context } = this.props;
      const { apiService } = context;
      const storyId = match.params.id;
      const { lastBranchesSyncTime } = this.state;

      let freshBranches;
      let newSyncTime;

      if (lastBranchesSyncTime) {
        const result = await apiService.fetchStoryBranchesChanges(storyId, lastBranchesSyncTime);
        newSyncTime = result.serverTime;

        if (result.full) {
          freshBranches = result.branches;
        } else {
          // Patch existing cache: merge changed/new nodes by id (preserves order for new ones
          // appended at the end — same approach as loadBranchListV2:1290-1294).
          const byId = {};
          this.state.branch.forEach((b) => { byId[b.id] = b; });
          result.branches.forEach((b) => { byId[b.id] = b; });
          const ids = Object.keys(byId).map(Number).sort((a, b) => a - b);
          freshBranches = ids.map((id) => byId[id]);
        }
      } else {
        // No sync time yet — skip revalidate, use existing cache.
        freshBranches = this.state.branch;
      }

      // Race check: if user clicked another node while we awaited, abort this open.
      if (this._pendingOpenBranchId !== requestedId) {
        return;
      }

      // Commit the refreshed cache and sync time atomically.
      if (newSyncTime != null) {
        this.setState({ branch: freshBranches, lastBranchesSyncTime: newSyncTime });
      } else {
        this.setState({ branch: freshBranches });
      }

      // Find the (now fresh) node.
      const freshNode = freshBranches.find((b) => b.id === requestedId) ?? branchData;

      // Compute client-side links_from / links_to (getAllV3 does not include them).
      const inboundIndex = buildInboundIndex(freshBranches);
      const linksTo = getLinksTo(freshNode.id, freshBranches);
      const linksFrom = getLinksFrom(freshNode.id, inboundIndex);

      this.initAddBranch({
        ...freshNode,
        // eslint-disable-next-line camelcase
        links_to: linksTo,
        // eslint-disable-next-line camelcase
        links_from: linksFrom,
        editStepId: branchData.editStepId ?? null,
      });
    } catch (err) {
      // Revalidate failed (network error, etc.) — open with whatever data we have.
      // This matches the pre-R1 behaviour and never blocks the author.
      if (this._pendingOpenBranchId === requestedId) {
        this.initAddBranch(branchData);
      }
    }
  };

  cancelAddBranch = () => {
    const { match } = this.props;
    let { newStories } = this.state;

    if (newStories === match.params.id) {
      newStories = null;
      sessionStorage.removeItem('newStories');
    }
    this.setState({
      editBranchData: null,
      addBranchActive: false,
      ConfirmationCancelAddBranch: false,
      AddBranchEdit: false,
      pendingGotoNode: null,
      saveAndContinueTarget: null,
      newStories,
    });
  };

  branchesLinesObj(fromID, toID, type, index) {
    const { selectionItems } = this.state;

    const fromElm = document.getElementById(`branches_${fromID}`);
    const toElm = document.getElementById(`branches_${toID}`);

    if (!fromElm || !toElm) {
      return null;
    }

    const selectedNode = selectionItems.find((node) => Number(node) === fromID || Number(node) === toID);
    const currentNodeFromClass = Number(selectedNode) === fromID ? 'currentNodeFrom' : undefined;
    const currentNodeToClass = Number(selectedNode) === toID ? 'currentNodeTo' : undefined;

    const wf = fromElm.clientWidth / 2;
    const hf = fromElm.clientHeight / 2;
    const wt = toElm.clientWidth / 2;
    const ht = toElm.clientHeight / 2;

    const dy = (toElm.offsetTop + ht) - (fromElm.offsetTop + hf);
    const dx = (toElm.offsetLeft + wt) - (fromElm.offsetLeft + wf);

    const angle = (Math.atan2(dy, dx) * 180) / Math.PI;
    const length = Math.sqrt(dx * dx + dy * dy);

    const left = fromElm.offsetLeft + wf;
    const top = fromElm.offsetTop + hf;

    return (
      <BranchesLine
        key={index}
        type={type}
        fromID={fromID}
        toID={toID}
        left={left}
        top={top}
        length={length}
        angle={angle}
        currentNodeClass={currentNodeFromClass || currentNodeToClass}
      />
    );
  }

  branchesLines = () => {
    const { branch } = this.state;
    return branch.map((object, i) => {
      const edges = collectBranchEdges(object, i);
      return edges.map((edge) => this.branchesLinesObj(edge.fromID, edge.toID, edge.type, edge.index));
    });
  };

  updateBranch = () => {
    if (USE_DELTA_BRANCH_FETCH) {
      this.loadBranchListV2();
    } else {
      this.loadBranchList();
    }
  };

  findCascade = (nodes, res, node) => {
    const gotoNodeIds = collectCascadeIds(node);
    gotoNodeIds.forEach((gotoNodeId) => {
      const nextNode = nodes.find((el) => el.id === gotoNodeId);
      if (typeof nextNode !== 'undefined' && !res.includes(nextNode.id)) {
        res.push(nextNode.id);
        this.findCascade(nodes, res, nextNode);
      }
    });
  };

  findCascadeNodes = (data, start) => {
    const nodes = [];
    const startNode = data.find((el) => el.id === start);
    nodes.push(startNode.id);
    this.findCascade(data, nodes, startNode);
    return nodes;
  };

  selectCascade = (branchId) => {
    const { branch } = this.state;
    const ids = this.findCascadeNodes(branch, branchId);
    this.setSelectionItems(ids);
  };

  handleCopy = async () => {
    const { selectionItems, branch, story } = this.state;
    if (selectionItems.length === 0) return;

    const selected = branch.filter((b) => selectionItems.includes(b.id));
    const payload = {
      type: CLIPBOARD_TYPE,
      version: 1,
      bookId: story.bookId,
      storyId: story.id,
      branchIds: selected.map((b) => b.id),
      branchNames: selected.map((b) => b.title),
    };
    try {
      await writeClipboard(payload);
      showToast({ textMessage: `Copied ${selected.length} node(s)`, variant: 'success' });
    } catch {
      showToast({ textMessage: 'Failed to copy: clipboard access denied', variant: 'warning' });
    }
  };

  handlePasteIntent = async () => {
    const { authUser, story } = this.state;
    if (isLiveEditDisabled(authUser.role, story.group)) {
      return;
    }
    const payload = await readClipboard();
    if (!payload) {
      showToast({ textMessage: 'No copied nodes found in clipboard', variant: 'warning' });
      return;
    }

    if (!isSameBook(payload, story.bookId)) {
      showToast({ textMessage: 'Cross-book paste is not supported yet', variant: 'warning' });
      return;
    }

    this.setState({
      selectionItems: payload.branchIds,
      isDuplicateMode: true,
    });
  };

  handleUndoPaste = () => {
    // TODO: Implement undo paste (delete lastPastedBranchIds)
  };

  duplicateBranchsLoading = (position) => {
    const { match } = this.props;
    const { selectionItems } = this.state;

    this.setState({ savePositionLoading: true });

    const data = {};
    data.branches = selectionItems;
    data.position = position;
    api.post(`/v1/stories/${match.params.id}/branches/duplicate`, data)
      .then((res) => {
        this.setSelectionItems(res.data.branches);
        const lastEditNode = res.data.branches[res.data.branches.length - 1];

        this.setState({
          savePositionLoading: false,
          lastEdit: lastEditNode,
          isDuplicateMode: false,
          lastPastedBranchIds: res.data.branches,
        }, () => {
          this.loadBranchList();
        });
      })
      .then(this.updatePreviewAllBranches)
      .catch(() => {
        this.setState({
          savePositionLoading: false,
          isDuplicateMode: false,
        });
        showToast({ textMessage: 'Failed to paste nodes', variant: 'warning' });
      });
  };

  duplicateBranchs = () => {
    this.setState({ isDuplicateMode: true });
  };

  sharedSettingsUpdate = () => {
    const { sharedSettingsPanel } = this.state;

    this.setState({
      sharedSettingsPanel: !sharedSettingsPanel,
    });
  };

  onBranchNameEdit = (val) => {
    this.setState({ branchOnNameEdit: val });
  };

  handleBranchClick = (branchId) => {
    const { authUser, story, modeEdit } = this.state;

    if (isLiveEditDisabled(authUser.role, story.group) || !modeEdit) {
      this.setState({ lastEdit: branchId });
      this.updatePreviewCurrentBranch(branchId);
    } else if (FEATURE_NODE_EDIT_SIDE_PANEL) {
      this.updatePreviewCurrentBranch(branchId);
    }
  };

  branchesItems() {
    const { match } = this.props;
    const {
      branch: branches,
      modeEdit,
      newBranchId,
      lastEdit,
      limits,
      keyDownFlag,
      handleSize,
      destinationNodeId,
      story,
      savePositionLoading,
      branchesScale,
      authUser,
      sourceNodeId,
      isAnalyticsVisible,
      selectionItems,
      branchOnNameEdit,
      experimentalHideCardDetails,
      experimentalDynamicBranchRendering,
    } = this.state;

    const { context } = this.props;
    const { memoryBankContext } = context;

    const storyId = match.params.id;
    const isAnotherKeysPressed = keyDownFlag.Alt || keyDownFlag.Control || keyDownFlag.Meta;
    const disabled = (keyDownFlag.Shift && !isAnotherKeysPressed)
      || !modeEdit
      || PremiumIpDisabledEdit(authUser.role, story.book, story.group)
      || PremiumIpDisabledApprovedEdit(authUser.role, story.book)
      || isLiveEditDisabled(authUser.role, story.group)
      || !!sourceNodeId;

    const scrollViewport = this._scrollViewport;
    const virtualize = experimentalDynamicBranchRendering
      && branches.length >= VIRTUALIZE_BRANCH_THRESHOLD
      && scrollViewport != null;

    return branches.map((branch) => {
      // DOR-10663: keep the connection source mounted while the user is drawing
      // a link arrow — its ConnectionButton.componentDidUpdate is what fires the
      // PATCH request when destinationNodeId changes. Virtualizing it breaks the flow.
      if (virtualize && branch.id !== sourceNodeId && !isBranchInViewport(branch, scrollViewport, handleSize, VIEWPORT_BUFFER_PX)) {
        return (
          <div
            key={branch.id}
            id={`branches_${branch.id}`}
            role="presentation"
            style={{
              position: 'absolute',
              left: branch.x != null && branch.x >= 0 ? branch.x : 0,
              top: branch.y != null && branch.y >= 0 ? branch.y : 0,
              width: handleSize.x,
              height: handleSize.y,
              visibility: 'hidden',
              pointerEvents: 'none',
            }}
          />
        );
      }
      const { x } = branch;
      const { y } = branch;
      const handleStyle = x !== null ? {
        position: 'absolute',
        left: x < 0 ? 0 : x,
        top: y < 0 ? 0 : y,
        width: handleSize.x,
      } : {
        backgroundColor: 'rgba(0, 0, 0, .1)',
        width: handleSize.x,
      };

      const isDecisionPoint = isDecisionStep(branch);
      const isHub = branch.steps?.some((s) => Number(s.stepTypeId) === StepTypes.Hub);
      const decisionPoint = (isDecisionPoint || isHub) ? 'handle_branchesDecsionPoint' : '';
      const isSelected = selectionItems.includes(branch.id);
      const isLastEdit = lastEdit === branch.id && !isSelected;
      const handleLastEdit = isLastEdit ? 'handleLastEdit' : '';

      const dragObjClassName = `.handle_${branch.id}`;
      const dragObjClass = `handle handle_${branch.id} ${decisionPoint} ${handleLastEdit}`;

      const isCheck = isCheckStep(branch);
      const memorySlotData = getMemoryBankSlotDataById(memoryBankContext.memories, branch.check, this.state.characterAliasesById);

      return (
        <DraggableCore
          key={branch.id}
          handle={dragObjClassName}
          disabled={disabled || branchOnNameEdit}
          position={null}
          // grid={[1, 1]}
          onStart={(e, data) => this.handleStart(e, data, branch)}
          onDrag={(e, data) => this.handleDrag(e, data, branch)}
          onStop={(e, data) => this.handleStop(e, data, branch)}
        >
          {/* eslint-disable-next-line max-len */}
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <div
            className={dragObjClass}
            style={handleStyle}
            id={`branches_${branch.id}`}
            data-testid="branch-card"
            data-branch-id={branch.id}
            onClick={() => this.handleBranchClick(branch.id)}
            onDoubleClick={() => this.revalidateAndOpenBranch(branch)}
          >
            {!experimentalHideCardDetails && <BranchItemBadge steps={branch.steps} />}
            <SelectableComponent
              {...this.props}
              selectableId={branch.id}
              selectionItems={selectionItems}
            >
              <BranchItem
                onDeleteSuccess={this.handleBranchDelete}
                branchNode={branch}
                actionEditBranch={this.revalidateAndOpenBranch}
                update={this.updateBranch}
                duplicate={this.duplicateBranchs}
                selectCascade={this.selectCascade}
                storyId={storyId}
                storyGroup={story ? story.group : null}
                disabled={disabled}
                limits={limits}
                newBranchId={newBranchId || null}
                clearSelection={this.handleSelectionClear}
                onError={this.handleOnError}
                onEdit={this.onBranchNameEdit}
                mainContent={this.mainContent}
                destinationNodeId={destinationNodeId}
                branchesScale={branchesScale}
                sourceNodeId={sourceNodeId}
                savePositionLoading={savePositionLoading}
                updateLoading={(val) => {
                  this.setState({
                    savePositionLoading: val,
                  });
                }}
                updateConnection={(id, type) => {
                  this.setState({
                    sourceNodeId: id,
                    sourceNodeIdType: type,
                    destinationNodeId: null,
                  });
                }}
                isAnalyticsVisible={isAnalyticsVisible}
                isCheckStep={isCheck}
                memorySlotData={memorySlotData}
                isLastEdit={isLastEdit}
                compact={experimentalHideCardDetails}
              />
            </SelectableComponent>
            {/* eslint-disable-next-line max-len */}
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div
              className={`hoverConnection ${sourceNodeId ? 'd-block' : 'd-none'}`}
              onClick={() => {
                this.setState({
                  destinationNodeId: branch.id,
                });
              }}
            />
          </div>
        </DraggableCore>
      );
    });
  }

  branchesDragItem() {
    const {
      authUser,
      branchesDragItems,
      branch: branches,
      experimentalHideCardDetails,
    } = this.state;

    if (!branchesDragItems || branchesDragItems.length < 1) {
      return null;
    }
    const compact = experimentalHideCardDetails;
    return branchesDragItems.map((branchNode) => {
      const isDecisionPoint = isDecisionStep(branchNode);
      const isHubNode = branchNode.steps?.some((s) => Number(s.stepTypeId) === StepTypes.Hub);
      const decisionPoint = (isDecisionPoint || isHubNode) ? 'handle_branchesDecsionPoint' : '';
      const isCheck = isCheckStep(branchNode);
      return (
        <div
          key={branchNode.id}
          id={`branchesDragItem-${branchNode.id}`}
          className={`branchesDragItem ${decisionPoint}`}
        >
          <BranchItem
            onDeleteSuccess={this.handleBranchDelete}
            branchNode={branchNode}
            disabled
            user={authUser}
            isCheckStep={isCheck}
            compact={compact}
          />
        </div>
      );
    });
  }

  initLocations() {
    this.setState({
      showLocations: true,
    });
  }

  validatePanelHide = () => {
    this.setState({
      validatePanel: false,
    });
  };

  sharedSettingsPanelHide = () => {
    this.setState({
      sharedSettingsPanel: false,
    });
  };

  infoPanelHide = () => {
    this.setState({
      infoPanel: false,
    });
  };

  branchesListPanelHide = () => {
    this.setState({
      branchesListPanel: false,
    });
  };

  handleDoubleClickItem(e) {
    const {
      snapToGrid,
      branchesScale,
      isDuplicateMode,
      grid,
      story,
      savePositionLoading,
    } = this.state;

    if (savePositionLoading) {
      return;
    }

    if (['live', 'liveprompt'].includes(story.group)) {
      return;
    }
    const wrapBox = this.mainContentWrapper.current.getBoundingClientRect();
    const wrapBoxLeft = wrapBox ? wrapBox.left : 0;
    const wrapBoxTop = wrapBox ? wrapBox.top : 0;
    const snapToGridX = snapToGrid === true ? grid : 1;
    const snapToGridY = snapToGrid === true ? grid : 1;
    const obj = {
      // eslint-disable-next-line max-len
      x: Math.round(((e.clientX - wrapBoxLeft - (snapToGridX / 2)) / branchesScale) / snapToGridX) * snapToGridX,
      // eslint-disable-next-line max-len
      y: Math.round(((e.clientY - wrapBoxTop - (snapToGridY / 2)) / branchesScale) / snapToGridY) * snapToGridY,
      number: 1,
    };

    if (isDuplicateMode) {
      this.duplicateBranchsLoading(obj);
      return;
    }

    this.initAddBranch(obj);
  }

  startScroll = (side, e) => {
    clearInterval(this.scrollInterval);
    const mainContent = this.mainContent.current;
    if (!side || !mainContent) {
      return;
    }
    const offset = 5;
    const interval = 7;

    this.scrollInterval = setInterval(() => {
      switch (side) {
        case 'right':
          mainContent.scrollBy({
            left: offset,
            behavior: 'instant',
          });
          break;
        case 'left':
          mainContent.scrollBy({
            left: -offset,
            behavior: 'instant',
          });
          break;
        case 'top':
          mainContent.scrollBy({
            top: -offset,
            behavior: 'instant',
          });
          break;
        case 'bottom':
          mainContent.scrollBy({
            top: offset,
            behavior: 'instant',
          });
          break;
        default:
          break;
      }
      mainContent.dispatchEvent(e);
    }, interval);
  };

  stopScroll = () => {
    clearInterval(this.scrollInterval);
    this.scrollInterval = null;
  };

  onMouseMove = async (e) => {
    const {
      keyDownFlag,
      dragStart,
    } = this.state;

    const mainContentElement = this.mainContent.current;

    /*
    0: No button or un-initialized
    1: Primary button (usually the left button)
    2: Secondary button (usually the right button)
    4: Auxiliary button (usually the mouse wheel button or middle button)
    8: 4th button (typically the "Browser Back" button)
    16 : 5th button (typically the "Browser Forward" button)
     */
    if (keyDownFlag.Shift === true) {
      if (e.buttons === 1 || e.buttons === 2) {
        mainContentElement.scrollTo({
          top: mainContentElement.scrollTop - e.movementY,
          left: mainContentElement.scrollLeft - e.movementX,
          behavior: 'instant',
        });
      }
      return;
    }

    if (!dragStart) {
      return;
    }

    const mainContentRect = mainContentElement.getBoundingClientRect();

    const willScrollBottom = window.innerHeight - e.clientY < 100;
    const willScrollLeft = e.clientX - mainContentRect.x < 100 && mainContentElement.scrollLeft > 0;
    const willScrollRight = (mainContentRect.x + mainContentRect.width) - e.clientX < 100;
    const willScrollTop = e.clientY - mainContentRect.y < 150 && mainContentElement.scrollTop > 0;
    const willScrollStop = !willScrollBottom && !willScrollLeft && !willScrollRight && !willScrollTop && this.scrollInterval;

    if (willScrollStop) {
      this.stopScroll();
      return;
    }

    if (willScrollBottom && !this.scrollInterval) {
      this.startScroll('bottom', e);
    }

    if (willScrollLeft && !this.scrollInterval) {
      this.startScroll('left', e);
    }
    if (willScrollRight && !this.scrollInterval) {
      this.startScroll('right', e);
    }

    if (willScrollTop && !this.scrollInterval) {
      this.startScroll('top', e);
    }
  };

  onLocationSelected = (locationId) => {
    this.setState({
      lastLocation: locationId,
    });
  };

  validateBadge = () => {
    const {
      error,
      warning,
    } = this.state;

    return (
      <>
        Validate
        <span className="boxBadge">
          {(warning || warning > 0) && (
            <Badge pill variant="warning">
              {warning || 0}
            </Badge>
          )}
          {(error || error > 0) && (
            <Badge pill variant="danger">
              {error || 0}
            </Badge>
          )}
        </span>
      </>
    );
  };

  partialEditBadge = () => (
    <>
      Partial Edit
      <span className="boxBadge">
        <Badge pill variant="danger">
          Experimental
        </Badge>
      </span>
    </>
  );

  importAsTextBadge = () => (
    <>
      Import as text
      <span className="boxBadge">
        <Badge pill variant="danger">
          Beta
        </Badge>
      </span>
    </>
  );

  exportAsTextBadge = () => (
    <>
      Export as text
      <span className="boxBadge">
        <Badge pill variant="danger">
          Beta
        </Badge>
      </span>
    </>
  );

  // TODO: Need to implement
  // setLastEdit = (branchId) => {
  //   if (!branchId) {
  //     return;
  //   }
  //
  //   this.setState({
  //     lastEdit: branchId,
  //   });
  //
  //   this.scrollToBranch(branchId);
  // };

  actionEditCharacters = () => {
    this.setState({
      editCharactersActive: true,
    });
  };

  actionEditCover = () => {
    const { editCoverActive } = this.state;

    this.setState({
      editCoverActive: !editCoverActive,
    });
  };

  actionBookCover = () => {
    const { showBookCover } = this.state;

    this.setState({
      showBookCover: !showBookCover,
    });
  };

  actionChapterRestore = () => {
    const { showChapterRestore } = this.state;

    this.setState({
      showChapterRestore: !showChapterRestore,
    });
  };

  editCover() {
    const {
      authUser,
      editCoverActive,
      modeEdit,
      story,
    } = this.state;

    if (editCoverActive) {
      return (
        <CoverEditor
          obj={this.state}
          onHide={this.actionEditCover}
          viewOnly={
            (
              (
                authUser.role !== 'admin'
                && story.story_role === 'viewer'
              )
              || !modeEdit
              || PremiumIpDisabledEdit(authUser.role, story.book, story.group)
              || PremiumIpDisabledApprovedEdit(authUser.role, story.book)
              || isLiveEditDisabled(authUser.role, story.group)
            )
          }
          update={() => {
            this.loadStory();
          }}
        />
      );
    }
    return null;
  }

  characters() {
    const {
      modeEdit,
      editCharactersActive,
      limits,
      authUser,
      story,
      showImagePath,
    } = this.state;

    const { context } = this.props;

    if (editCharactersActive) {
      return (
        <Characters
          user={authUser}
          book={story.book}
          id={String(story.book.id)}
          title={story.book.title}
          show={editCharactersActive}
          onHide={() => {
            this.setState({ editCharactersActive: false });
            this.loadBranchList();
            this.updatePreviewAllBranches();
            if (FEATURE_NODE_EDIT_SIDE_PANEL) {
              context.bookCharactersContext.fetchBookCharacters(story.book.id);
            }
          }}
          disabledEdit={
            !modeEdit
            || PremiumIpDisabledEdit(authUser.role, story.book, story.group)
            || PremiumIpDisabledApprovedEdit(authUser.role, story.book)
            || isLiveEditDisabled(authUser.role, story.group)
          }
          disabled={
            (
              !modeEdit
              || (
                authUser.role !== 'admin'
                && story.book.book_role !== 'owner'
                && story.book.book_role !== 'editor'
                && story.book.book_role !== 'co-author'
              )
            )
          }
          limits={limits}
          showImagePath={showImagePath}
          context={context}
        />
      );
    }
    return null;
  }

  previewClose = () => {
    stopAllAudio();
    allowAudio(false);
    this.setState({ preview: false });
  };

  handlePreviewUpdate = (val) => this.setState({ previewPanel: val });

  goLiveTitle = () => {
    const { story } = this.state;
    if (story && (story.book && !!story.book.original)) {
      return 'Submit';
    }
    if (story && story.live_count === 0) {
      return 'Release in the app';
    }
    if (story && story.live_count !== 0) {
      return 'Update in the app';
    }
    return '...';
  };

  livePromptTitle = () => {
    const { story } = this.state;
    if (story.group === 'liveprompt' || story.group === 'prompt') {
      return 'Publish Prompt';
    }
    return this.goLiveTitle();
  };

  handleAnyBranchUpdate = (maybeNewBranchInfo) => {
    const { match } = this.props;
    const { newStories } = this.state;
    if (newStories === match.params.id) {
      sessionStorage.removeItem('newStories');
      this.setState({
        newStories: null,
      });
    }
    this.loadBranchList(null, maybeNewBranchInfo);
  };

  handleAnyBranchUpdateV2 = (maybeNewBranchInfo) => {
    const { match } = this.props;
    const { newStories } = this.state;
    if (newStories === match.params.id) {
      sessionStorage.removeItem('newStories');
      this.setState({
        newStories: null,
      });
    }
    this.loadBranchListV2(null, maybeNewBranchInfo);
  };
  
  // Post-save cache invalidation is handled here for BOTH flag states: handleAnyBranchUpdateV2
  // -> loadBranchListV2 runs a delta fetch (/branches/changes?since=lastBranchesSyncTime),
  // patches state.branch[] and bumps lastBranchesSyncTime. So the side-panel feature (flag ON)
  // needs no separate invalidation branch — revalidateAndOpenBranch will see the fresh cache and
  // the next delta starts from the updated timestamp (no double work). R1 keeps the legacy save
  // behaviour (form closes on save); a keep-open / two-button save is deferred to R2 (UI rework).
  handleBranchUpdate = (branchId) => {
    if (this.state.saveAndContinueTarget !== null) {
      const target = this.state.saveAndContinueTarget;
      this.setState({ saveAndContinueTarget: null });
      this.revalidateAndOpenBranch(target);
      return;
    }
    this.setState({ addBranchActive: false });
    this.updatePreviewCurrentBranch(branchId);
    this.reRenderPreviewBranch();
    if (USE_DELTA_BRANCH_FETCH) {
      this.handleAnyBranchUpdateV2();
    } else {
      this.handleAnyBranchUpdate();
    }

    this.setState((prevState) => ({
      triggerRefresh: prevState.triggerRefresh + 1,
    }));
  };

  handleBranchCreate = (maybeNewBranchInfo) => {
    this.setState({ addBranchActive: false });
    this.updatePreviewAllBranches();
    if (USE_DELTA_BRANCH_FETCH) {
      this.handleAnyBranchUpdateV2(maybeNewBranchInfo);
    } else {
      this.handleAnyBranchUpdate(maybeNewBranchInfo);
    }
  };

  // Dismiss the first-run Side-by-Side Editor notice. Persisting the flag key
  // (value unchanged: the feature stays on) records the creator's choice so the
  // notice is shown only once per browser.
  handleDismissSidePanelAnnouncement = () => {
    try {
      localStorage.setItem('featureNodeEditSidePanel', JSON.stringify(true));
    } catch {
      // localStorage may be unavailable (private mode); the notice simply
      // reappears next session, which is acceptable.
    }
    this.setState({ showSidePanelAnnouncement: false });
  };

  addBranch = () => {
    const {
      lastLocation,
      branch,
      ConfirmationCancelAddBranch,
      stepTypes,
      addBranchActive,
      story,
      limits,
      AddBranchEdit,
      editBranchData,
      modeEdit,
      authUser,
      answerTypes,
      modifierTypes,
      requiresTypes,
      traitsTypes,
      pendingGotoNode,
    } = this.state;

    const { context } = this.props;
    const { memoryBankContext } = context;
    const { memories } = memoryBankContext;

    if (addBranchActive === true) {
      return (
        <>
          <AddBranchContextWrapper
            onSaveTriggerReady={this.handleSaveTriggerReady}
            branchesGroup={story.group}
            modeEdit={modeEdit}
            user={authUser}
            actionEditBranch={this.revalidateAndOpenBranch}
            branch={branch}
            story={story}
            storyId={this.props.match.params.id}
            data={editBranchData}
            stepTypes={stepTypes}
            show={addBranchActive}
            sidePanel={FEATURE_NODE_EDIT_SIDE_PANEL}
            edit={(e) => {
              this.setState({
                AddBranchEdit: e,
              });
            }}
            addBranchEdit={AddBranchEdit}
            onHide={() => {
              if (
                (authUser.role === 'admin' && !modeEdit)
                || (authUser.role !== 'admin' && story.book.book_role !== 'owner' && story.book.book_role !== 'editor' && story.book.book_role !== 'co-author')
                || !AddBranchEdit
                || (
                  story
                  && (story.book
                    && !!story.book.original
                    && ['live', 'liveprompt'].includes(story.group)
                  )
                )
              ) {
                this.cancelAddBranch();
              } else {
                this.setState({
                  ConfirmationCancelAddBranch: true,
                });
              }
            }}
            update={this.handleAnyBranchUpdate}
            onBranchUpdate={this.handleBranchUpdate}
            onBranchCreate={this.handleBranchCreate}
            disabled={
              !modeEdit
              // eslint-disable-next-line max-len
              || PremiumIpDisabledEdit(authUser.role, story.book, story.group)
              || PremiumIpDisabledApprovedEdit(authUser.role, story.book)
              || isLiveEditDisabled(authUser.role, story.group)
            }
            onLocationSelected={this.onLocationSelected}
            lastLocation={lastLocation}
            limits={limits}
            onError={this.handleOnError}
            restrictedEdit={['live', 'liveprompt'].includes(story.group)}
            memoryBank={memories}
            onBackgroundsChanged={this.refreshPreviewBackgrounds}
            answerTypes={answerTypes}
            modifierTypes={modifierTypes}
            requiresTypes={requiresTypes}
            traitsTypes={traitsTypes}
          />

          <CancelAddBranch
            show={ConfirmationCancelAddBranch}
            {...(pendingGotoNode !== null ? {
              title: 'Unsaved changes',
              confirmLabel: 'Continue without saving',
              dismissLabel: 'Cancel',
              onSaveAndContinue: () => {
                this.setState(
                  { saveAndContinueTarget: pendingGotoNode, ConfirmationCancelAddBranch: false, pendingGotoNode: null },
                  () => { this._triggerFormSave?.(); },
                );
              },
            } : {})}
            onHide={() => {
              if (pendingGotoNode !== null) {
                // Return the emulator cursor to the node being edited. Pass undefined
                // (not null) as the step index when the node has steps: null forces the
                // empty-node frame (cursor.stepIndex === null), and computeForwardFallback
                // returns null for a null step index, so forward navigation silently stops
                // and the author gets stuck on this node. undefined resolves to step 0.
                const stepIndex = (editBranchData?.steps_count ?? 0) > 0 ? undefined : null;
                this._deferredNavigate.invoke(editBranchData.id, stepIndex);
              }
              this.setState({
                ConfirmationCancelAddBranch: false,
                pendingGotoNode: null,
              });
            }}
            update={() => {
              if (pendingGotoNode !== null) {
                this.setState({ ConfirmationCancelAddBranch: false, pendingGotoNode: null });
                this.revalidateAndOpenBranch(pendingGotoNode);
              } else {
                this.cancelAddBranch();
              }
            }}
          />

        </>
      );
    }
    return false;
  };

  closeLocations = () => {
    const {
      newStories,
      story,
    } = this.state;
    const {
      match,
      context,
    } = this.props;
    const { bookLocationContext } = context;

    if (story.book?.id) {
      bookLocationContext.fetchBookLocations(story.book.id);
    }
    this.loadBranchList();
    this.updatePreviewAllBranches();

    this.setState({ showLocations: false });

    if (newStories === match.params.id) {
      sessionStorage.setItem('newStories', JSON.stringify({
        id: newStories,
        step: 2,
      }));
      this.newStorySteps();
    }
  };

  listLocations = () => {
    const {
      authUser,
      story,
      limits,
      modeEdit,
      showLocations,
    } = this.state;

    if (showLocations === true) {
      return (
        <Locations
          user={authUser}
          book={story.book}
          bookId={story.book.id}
          bookTitle={story.book.title}
          show={showLocations}
          onHide={this.closeLocations}
          disabled={!modeEdit}
          limits={limits}
          disabledEdit={
            !modeEdit
            // eslint-disable-next-line max-len
            || PremiumIpDisabledEdit(authUser.role, story.book, story.group)
            || PremiumIpDisabledApprovedEdit(authUser.role, story.book)
            || isLiveEditDisabled(authUser.role, story.group)
          }
          onBackgroundsChanged={this.refreshPreviewBackgrounds}
        />
      );
    }
    return false;
  };

  closeStoryNotFound = () => {
    window.location.assign('/stories');
  };

  storyNotFound = () => {
    const { notFound } = this.state;
    if (notFound !== true) {
      return null;
    }
    return (
      <NotFoundModal
        show={notFound}
        onHide={this.closeStoryNotFound}
      />
    );
  };

  editBookTags = () => {
    const {
      authUser,
      story,
      showEditBookTags,
      modeEdit,
    } = this.state;

    if (showEditBookTags === true) {
      return (
        <BookTagsModal
          book={story.book}
          show={showEditBookTags}
          disabled={
            !modeEdit
            || PremiumIpDisabledEdit(authUser.role, story.book, story.group)
            || PremiumIpDisabledApprovedEdit(authUser.role, story.book)
            || isLiveEditDisabled(authUser.role, story.group)
          }
          onHide={() => {
            this.setState({ showEditBookTags: false });
          }}
          update={() => {
            this.setState({ showEditBookTags: false });
          }}
        />
      );
    }
    return false;
  };

  renderBookCover = () => {
    const {
      showBookCover,
      story,
      authUser,
    } = this.state;

    if (showBookCover) {
      return (
        <BookCover
          user={authUser}
          book={story.book}
          show={showBookCover}
          onHide={this.actionBookCover}
          update={() => {
            this.loadSettings();
            this.loadBranchList();
            this.loadStory();
            this.newStorySteps();
            this.actionBookCover();
          }}
          disabled={(
            !(story && story.book)
            || (
              authUser.role !== 'admin'
              && story.book.book_role !== 'owner'
              && story.book.book_role !== 'editor'
              && story.book.book_role !== 'co-author'
            )
          )}
        />
      );
    }
    return null;
  };

  renderChapterRestore = () => {
    const {
      story,
      showChapterRestore,
    } = this.state;

    if (!showChapterRestore) {
      return null;
    }

    return (
      <ChapterRestoreModal
        book={story.book}
        obj={story}
        show
        update={this.loadBranchList}
        onHide={() => {
          this.setState({ showChapterRestore: false });
        }}
      />
    );
  };

  storyBranchesPage = () => {
    const {
      authUser,
      keyDownFlag,
      branch,
      snapToGrid,
      branchesListPanel,
      addBranchActive,
      branchesScale,
      story,
      validatePanel: validatePanel1,
      GoLiveLoading,
      limits: propsLimits,
      scrollToNode,
      showGrid,
      preview,
      infoPanel,
      previewPanel: propsPreviewPanel,
      modeEdit,
      savePositionLoading,
      experimentalHideCardDetails,
      experimentalDynamicBranchRendering,
      experimentalNodeEditSidePanel,
    } = this.state;

    const { match } = this.props;

    const validatePanel = infoPanel || branchesListPanel || validatePanel1 ? 'main-panel-sm' : null;
    const previewPanel = propsPreviewPanel ? 'preview-panel' : null;
    const REACT_APP_LIVE = process.env.REACT_APP_LIVE !== undefined && process.env.REACT_APP_LIVE && process.env.REACT_APP_LIVE === 'true';
    const limits = propsLimits && Object.entries(propsLimits).length > 0 ? propsLimits : undefined;

    const isRenPyRunner = story?.runner === EpisodeRunners.RenPy;

    const publishDisabled = !(story.group === 'active' || story.group === 'prompt')
      || GoLiveLoading
      || (authUser.role !== 'admin' && ['viewer', 'editor'].includes(story.story_role) && !story.canPublish)
      || !modeEdit
      || PremiumIpDisabledEdit(authUser.role, story.book, story.group)
      || PremiumIpDisabledApprovedEdit(authUser.role, story.book)
      || isLiveEditDisabled(authUser.role, story.group);

    const page = {
      header: {
        title: story.title ? `Episode: ${story.title}` : `Episode # ${match.params.id}`,
        type: 'branches',
        settings: (authUser.role === 'admin') && 'branches',
        settingsItems: (authUser.role === 'admin') && [
          {
            title: 'Node Positioning',
            disabled: !modeEdit,
            action: () => {
              this.setState({
                NodePositioningModal: true,
              });
            },
          },
        ],
      },
      sidebar: {
        nav: [
          {
            title: 'Back to book',
            href: `/book/${story.bookId}`,
            variant: 'secondary',
            disabled: !story.bookId,
          },
        ],
      },
    };

    if (isEmpty(story)) {
      return page;
    }

    if (isRenPyRunner) {
      return {
        ...page,
        sidebar: {
          nav: [
            {
              title: 'Back to book',
              href: `/book/${story.bookId}`,
              variant: 'secondary',
              disabled: !story.bookId,
            },
            REACT_APP_LIVE
            && {
              title: this.livePromptTitle(),
              action: () => {
                this.setState({
                  GoLiveModal: true,
                });
              },
              loading: GoLiveLoading,
              variant: story.group === 'active' || story.group === 'prompt' ? 'success' : 'secondary',
              disabled: publishDisabled,
            },
            {
              variant: 'space',
            },
            {
              title: 'Episode Settings',
              variant: 'Options',
              ref: this.optionsRef,
              id: this.props.match.params.id,
              user: authUser,
              update: () => this.loadStory(),
              limits,
              modeEdit: modeEdit
                || PremiumIpDisabledEdit(authUser.role, story.book, story.group)
                || PremiumIpDisabledApprovedEdit(authUser.role, story.book)
                || isLiveEditDisabled(authUser.role, story.group),
              story,
            },
            {
              title: this.validateBadge(),
              action: () => {
                this.setState((prevState) => ({
                  validatePanel: !prevState.validatePanel,
                }));
              },
              variant: 'primary',
              disabled: false,
            },
          ],
        },
      };
    }

    return {
      header: {
        title: story.title ? `Episode: ${story.title}` : `Episode # ${match.params.id}`,
        type: 'branches',
        settings: (authUser.role === 'admin') && 'branches',
        settingsItems: (authUser.role === 'admin') && [
          {
            title: 'Node Positioning',
            disabled: !modeEdit,
            action: () => {
              this.setState({
                NodePositioningModal: true,
              });
            },
          },
        ],
        contentRef: this.mainContent,
        mainContentStyle: keyDownFlag.Shift ? 'content-branches-shift content-branches' : 'content-branches',
        mainContentPanel: ` ${validatePanel} ${previewPanel} `,
      },
      sidebar: {
        nav: [
          {
            title: 'Back to book',
            href: `/book/${story.bookId}`,
            variant: 'secondary',
            disabled: !story.bookId,
          },
          {
            title: !preview ? 'Play in emulator' : 'Close emulator',
            action: () => {
              this.setState((state) => {
                const newPreview = !state.preview;
                const newPreviewPanel = !state.previewPanel;
                allowAudio(newPreview);
                if (!newPreview) {
                  stopAllAudio();
                }
                return { preview: newPreview, previewPanel: newPreviewPanel };
              });
            },
            variant: 'success',
            disabled: branch.length < 1,
            activeWizardStep: 10,
          },
          {
            title: 'Share emulator link',
            variant: 'success',
            action: () => {
              this.setState({
                shareModal: true,
              });
            },
            disabled: story && story.book && story.book.original,
          },
          REACT_APP_LIVE
          && {
            title: this.livePromptTitle(),
            action: () => {
              this.setState({
                GoLiveModal: true,
              });
            },
            loading: GoLiveLoading,
            variant: story.group === 'active' || story.group === 'prompt' ? 'success' : 'secondary',
            disabled: publishDisabled,
          },
          {
            title: 'Create Node',
            variant: 'CreateNodeButton',
            branchesScale,
            addBranchActive,
            modeEdit: !modeEdit
              || PremiumIpDisabledEdit(authUser.role, story.book, story.group)
              || PremiumIpDisabledApprovedEdit(authUser.role, story.book)
              || isLiveEditDisabled(authUser.role, story.group),
            action: this.addBranches,
          },
          {
            title: 'Search',
            action: () => {
              this.setState((prevState) => ({
                branchesListPanel: !prevState.branchesListPanel,
              }));
            },
            variant: 'primary',
          },
          {
            title: 'Character Skins',
            action: () => this.actionEditCharacters(),
            variant: 'primary',
            disabled: false,
          },
          {
            title: 'Locations',
            action: () => this.initLocations(),
            variant: 'primary',
            disabled: false,
            activeWizardStep: 8,
          },
          {
            title: 'Video',
            href: '/video-library',
            variant: 'primary',
            NotAdminPermissions: !isVideosEnabled(),
          },
          {
            title: 'Audio',
            href: '/audio-library',
            variant: 'primary',
            NotAdminPermissions: !isAudiosEnabled(),
          },
          {
            title: 'Memory Bank',
            action: () => this.setState({ showMemoryBank: true }),
            variant: 'primary',
            disabled: false,
            NotAdminPermissions: !isMemoryBankEnabled(),
          },
          {
            title: 'Achievements',
            action: () => this.setState({ showAchievementsModal: true }),
            variant: 'primary',
            disabled: false,
            NotAdminPermissions: !(isMemoryBankEnabled() && isAchievementsEnabled()),
          },
          {
            title: 'Tag Templates',
            action: () => this.setState({ showHubTagTemplatesModal: true }),
            variant: 'primary',
            disabled: false,
          },
          {
            title: 'Episode Goals',
            action: () => this.setState({ showPerformanceRanksModal: true }),
            variant: 'primary',
            disabled: false,
            activeWizardStep: 8,
            NotAdminPermissions: !isMemoryBankEnabled(authUser),
          },
          {
            variant: 'space',
          },
          {
            title: this.validateBadge(),
            action: () => {
              this.setState((prevState) => ({
                validatePanel: !prevState.validatePanel,
              }));
            },
            variant: 'primary',
            disabled: false,
          },
          {
            title: 'Edit Story Tags',
            action: () => this.setState({ showEditBookTags: true }),
            variant: 'primary',
            disabled:
              authUser.role !== 'admin'
              && !(
                story.book
                && ['owner', 'editor', 'co-author'].includes(story.book.book_role))
            ,
          },
          {
            title: 'Episode Settings',
            variant: 'Options',
            ref: this.optionsRef,
            id: this.props.match.params.id,
            user: authUser,
            update: () => this.loadStory(),
            limits,
            modeEdit: modeEdit
              || PremiumIpDisabledEdit(authUser.role, story.book, story.group)
              || PremiumIpDisabledApprovedEdit(authUser.role, story.book)
              || isLiveEditDisabled(authUser.role, story.group),
            story,
          },
          {
            variant: 'space',
          },
          {
            title: 'Snap to Grid',
            action: () => {
              this.setState((state) => ({ snapToGrid: !state.snapToGrid }));
            },
            variant: 'snapToGridCheckbox',
            id: 'snapToGrid',
            disabled: !modeEdit,
            value: snapToGrid,
          },

          {
            title: 'Show grid',
            action: () => {
              this.setState((state) => ({ showGrid: !state.showGrid }));
            },
            variant: 'showGridCheckBox',
            id: 'showGrid',
            disabled: !modeEdit,
            value: showGrid,
          },

          {
            title: 'Scroll to node',
            action: () => {
              this.setState((state) => ({ scrollToNode: !state.scrollToNode }));
            },
            variant: 'showGridCheckBox',
            id: 'scrollToNode',
            value: scrollToNode,
          },
          {
            action: (newScale) => {
              const container = this.mainContent.current;
              const rect = container.getBoundingClientRect();
              // Zoom toward viewport center
              const centerX = rect.width / 2;
              const centerY = rect.height / 2;
              this.animateZoomToPoint(newScale, centerX, centerY);
            },
            variant: 'zoom',
            branchesScale,
          },
          {
            title: 'See Whole Episode',
            action: () => {
              const branches = branch;
              const maxX = branches.reduce((prev, curr) => (prev > curr.x ? prev : curr.x));
              const minX = branches.reduce((prev, curr) => (prev < curr.x ? prev : curr.x));
              const maxY = branches.reduce((prev, curr) => (prev > curr.y ? prev : curr.y));
              const minY = branches.reduce((prev, curr) => (prev < curr.y ? prev : curr.y));
              const box = this.mainContent.current.getBoundingClientRect();
              const val = Math.min(1, box.width / (maxX + minX + 200), box.height / (maxY + minY + 200));

              this.setState({
                branchesScale: val,
              });
              const obj = this.mainContent.current;
              obj.scrollTo(0, 0);
            },
            variant: 'primary',
            disabled: authUser.role !== 'admin' && story.story_role !== 'owner',
          },
          {
            title: 'Restore this version',
            action: () => this.actionChapterRestore(),
            variant: 'primary',
            disabled:
              (
                authUser.role !== 'admin'
                && story.story_role !== 'owner'
              )
              || !modeEdit
              || PremiumIpDisabledEdit(authUser.role, story.book, story.group)
              || PremiumIpDisabledApprovedEdit(authUser.role, story.book)
              || isLiveEditDisabled(authUser.role, story.group),
            NotAdminPermissions: !(story && ['submitted', 'rejected', 'approved', 'pending', 'live', 'liveprompt', 'prompt'].includes(story.group)),
          },
          { variant: 'space' },
          {
            title: 'Info',
            action: () => {
              this.setState((prevState) => ({
                infoPanel: !prevState.infoPanel,
              }));
            },
            variant: 'primary',
            disabled: false,
          },
          {
            title: this.importAsTextBadge(),
            action: () => this.setState({ showImportTextModal: true }),
            variant: 'primary',
            disabled: savePositionLoading || !modeEdit,
          },
          {
            title: this.partialEditBadge(),
            action: () => this.setState({ showSelectiveEditModal: true }),
            variant: 'primary',
            disabled: savePositionLoading || !modeEdit,
          },
          {
            title: this.exportAsTextBadge(),
            action: () => this.setState({ showExportTextModal: true }),
            variant: 'primary',
            disabled: savePositionLoading || this.state.branch.length === 0,
          },
          {
            title: 'Export',
            action: () => Export.exportStory(this.props.match.params.id, story.title),
            variant: 'primary',
            disabled: authUser.role !== 'admin' && story.story_role !== 'owner',
            NotAdminPermissions: !authUser || authUser.role !== 'admin',
          },
          {
            title: 'Help',
            action: () => {
              this.setState((prevState) => ({
                HelpPanel: !prevState.HelpPanel,
              }));
            },
            variant: 'primary',
          },
          { variant: 'space' },
          {
            variant: 'experimentalSection',
            hideCardDetails: experimentalHideCardDetails,
            dynamicBranchRendering: experimentalDynamicBranchRendering,
            nodeEditSidePanel: experimentalNodeEditSidePanel,
            onHideCardDetailsChange: (value) => {
              localStorage.setItem('experimentalHideCardDetails', JSON.stringify(value));
              this.setState({ experimentalHideCardDetails: value });
            },
            onDynamicBranchRenderingChange: (value) => {
              localStorage.setItem('experimentalDynamicBranchRendering', JSON.stringify(value));
              this.setState({ experimentalDynamicBranchRendering: value });
            },
            onNodeEditSidePanelChange: (value) => {
              // setState first so the switch flips instantly, then persist and reload —
              // the FEATURE_NODE_EDIT_SIDE_PANEL gate is module-level, so it only takes
              // effect on the next load (label says "reload to apply").
              this.setState({ experimentalNodeEditSidePanel: value });
              localStorage.setItem('featureNodeEditSidePanel', JSON.stringify(value));
              window.location.reload();
            },
          },
        ],
      },
    };
  };

  handleEditStep = (branchId, stepId) => {
    const { branch: branches } = this.state;
    if (!branchId || !stepId) {
      return;
    }
    const branch = branches.find((b) => b.id === branchId);
    // Use revalidateAndOpenBranch so that flag ON gets a fresh node from cache
    // (state.branch[] has no steps at this point — revalidate attaches them via
    // the delta fetch). Flag OFF: revalidateAndOpenBranch immediately falls through
    // to initAddBranch — identical to the previous behaviour.
    this.revalidateAndOpenBranch({
      ...branch,
      editStepId: stepId,
    });
  };

  render() {
    const {
      isAnalyticsVisible,
      storePublicInterface,
      story,
      authUser,
      redirect,
      selectionItems,
      keyDownFlag,
      isDuplicateMode,
      savePositionLoading,
      branchesScale,
      sourceNodeId,
      destinationNodeId,
      branchOnNameEdit,
      showMemoryBank,
      showAchievementsModal,
      showHubTagTemplatesModal,
      showImportTextModal,
      showExportTextModal,
      showSelectiveEditModal,
      branch: nodes,
      reFetchMemoriesTrigger,
      showPerformanceRanksModal,
      triggerRefresh,
    } = this.state;

    if (redirect) {
      return (<Redirect to={redirect} />);
    }

    if (!story.book) {
      return (
        <PageWrapper
          page={this.storyBranchesPage()}
        >
          <Spinner
            animation="border"
            variant="primary"
            className="story-branches-spinner justify-content-center"
          />
        </PageWrapper>
      );
    }

    // TODO: Remove this after RenPy is fully implemented

    const { context } = this.props;
    const {
      memoryBankContext,
      memoryIconsContext,
    } = context;

    const linkUrl = document.location.origin.replace('www.', '');
    const bookStyle = this.state.story.book && this.state.story.book.bookStyle;
    const bookStyleAlias = bookStyle && bookStyle.alias === 'arcana_style' ? 'arcana' : undefined;

    const isAdmin = authUser?.role === 'admin';
    const authorId = isAdmin ? undefined : authUser.id;
    const isSendNotifications = story?.book?.sendNotificationsFor?.includes(SendNotificationsFor.Achievement) ?? false;
    const isRenPyRunner = story?.runner === EpisodeRunners.RenPy;
    return (
      <AudiosProvider initialPageSize={null} authorId={authorId} bookId={story.book.id} triggerRefresh={triggerRefresh}>
        <VideosProvider initialPageSize={null} authorId={authorId}>
          <AchievementsContextProvider
            bookId={story?.book?.id}
            isSendNotifications={isAdmin && isSendNotifications}
          >
            <HubTagTemplatesContextProvider bookId={story?.book?.id}>
              {/* initialCursorBranchId comes from localStorage (last-visited node).
                  When it matches the first NAVIGATE target, that dispatch is a same-node
                  no-op in the reducer and does NOT push to historyBack — preventing the
                  phantom Back entry on fresh page load (A1). Falls back to 0 when no
                  localStorage entry exists (first ever visit): in that case the first
                  NAVIGATE still produces a phantom, which is the pre-existing behaviour. */}
              <CursorProvider initialCursor={{ branchId: this._initialCursorBranchId, stepIndex: null }}>
                {FEATURE_NODE_EDIT_SIDE_PANEL && (
                  <CursorNavigateConnector
                    onNavigateReady={this.handleCursorNavigateReady}
                    onResetReady={this.handleCursorResetReady}
                  />
                )}
                {FEATURE_NODE_EDIT_SIDE_PANEL && (
                  <CursorScrollFollower
                    scrollToBranch={this.scrollToBranch}
                    onBranchIdChange={this.handleCursorBranchIdChange}
                  />
                )}
                {FEATURE_NODE_EDIT_SIDE_PANEL && this.state.showSidePanelAnnouncement && (
                  <SidePanelAnnouncement
                    onClose={this.handleDismissSidePanelAnnouncement}
                  />
                )}
                <PageWrapper
                  page={this.storyBranchesPage()}
                >
                  <div id="branches-dropdown-portal" />
                  {isRenPyRunner ? (
                    <Card>
                      <Card.Title className="text-center">
                        RenPy Game Settings
                      </Card.Title>
                      <Card.Body>
                        <RenPyGameSettings
                          episode={{
                            id: story.id,
                            uuid: story.uuid || story.internal_uuid,
                            revision: story.revision,
                            renpyContentUrl: story.renpyData?.content_url || null,
                            renpyOrientation: story.renpyData?.orientation || 1,
                          }}
                          bookUuid={story.book?.uuid || story.book?.internal_uuid}
                          isAdmin={authUser.role === 'admin'}
                          onSaveSuccess={() => this.loadStory()}
                          isEditable={!['live', 'liveprompt', 'livetest'].includes(story.group)}
                        />
                      </Card.Body>
                    </Card>
                  ) : (
                    <div
                      className={cs(`content-branches-wrapper branchesScale_${branchesScale * 100}`)}
                      style={{
                        '--scale': this._getCurrentScale(),
                        transform: `scale(${this._getCurrentScale()})`,
                        width: `${this.state.branchesWrapper.x}px`,
                        height: `${this.state.branchesWrapper.y}px`,
                      }}
                      ref={this.mainContentWrapper}
                    >

                      <div className={cs(`gridBg ${this.state.showGrid ? 'gridBgShow' : ''}`)} />

                      <div
                        className={cs([
                          'wrapItems',
                          this.state.sourceNodeId ? 'activeConnection' : '',
                          this.state.sourceNodeIdType === 'choice' ? 'activeConnectionChoice' : '',
                          this.state.dragStart || keyDownFlag.Shift || branchOnNameEdit ? 'SelectableGroupDisabled' : null])}
                      >

                        <SelectableGroup
                          ref={this.selectionRef}
                          className="wrapItems wrapItems-selection"
                          enableDeselect={keyDownFlag.Control || keyDownFlag.Meta}
                          mixedDeselect={keyDownFlag.Control || keyDownFlag.Meta}
                          resetOnStart={false}
                          globalMouse={false}
                          allowClickWithoutSelected={false}
                          onSelectionFinish={this.handleSelectionFinish}
                          ignoreList={['.not-selectable', '.DeselectAll-button']}
                          disabled={this.state.dragStart
                          || keyDownFlag.Shift
                          || branchOnNameEdit
                          || ['live', 'liveprompt'].includes(this.state.story.group)
                          || !!sourceNodeId}
                          delta={branchesScale}
                          allowCtrlClick
                        >
                          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                          <div
                            ref={this.scrollRef}
                            className={`content-dbClickArea ${isDuplicateMode ? ' cursor-point' : ''}`}
                          // // Used mouseUp instead onClick because SelectableGroup prevent onClick event
                            onMouseDown={(e) => {
                              if (!isDuplicateMode
                              && !(keyDownFlag.Control || keyDownFlag.Meta || keyDownFlag.Shift || keyDownFlag.Alt)
                              && !sourceNodeId
                              ) {
                                this.handleSelectionClear();
                              }
                              if (isDuplicateMode && this.state.modeEdit) {
                                this.handleDoubleClickItem(e);
                              }

                              if (sourceNodeId || destinationNodeId) {
                                this.setState({
                                  sourceNodeId: null,
                                  destinationNodeId: null,
                                });
                              }
                            }}
                            onDoubleClick={(e) => {
                              if (!isDuplicateMode && this.state.modeEdit) {
                                this.handleDoubleClickItem(e);
                              }
                            }}
                          />
                          {this.branchesItems()}
                        </SelectableGroup>
                      </div>

                      {this.branchesDragItem()}

                      <div className={cs('wrapLines')}>
                        {this.branchesLines()}
                      </div>

                      <div id="boxConnection" />

                    </div>
                  )}

                  {this.state.savePositionLoading && (
                    <Spinner
                      animation="border"
                      variant="primary"
                      className="story-branches-spinner justify-content-center"
                    />
                  )}

                  <div
                    className={`modeAlert ${this.state.modeAdminStyle}`}
                  >
                    <Alert
                      className={`${this.state.modeEditStyle}`}
                      variant={!this.state.modeEdit ? 'info' : 'danger'}
                    >
                      <Form.Check
                        custom
                        type="checkbox"
                        id="NodeEditMode"
                        label={
                          !this.state.modeEdit
                            ? 'Node Read-Only Mode'
                            : 'Node Edit Mode'
                        }
                        checked={this.state.modeEdit}
                        onChange={() => {
                          this.setState((prevState) => {
                            const modeEdit = !prevState.modeEdit;
                            localStorage.setItem(`modeEdit-${prevState.story.internal_uuid}`, !modeEdit);
                            localStorage.setItem('modeEdit', !modeEdit);
                            return {
                              modeEdit,
                            };
                          });
                        }}
                      />
                    </Alert>
                  </div>

                  {this.state.NodePositioningModal
                    && (
                      <NodePositioningModal
                        show={this.state.NodePositioningModal}
                        branch={this.state.branch}
                        storyId={this.props.match.params.id}
                        onHide={() => {
                          this.setState({
                            NodePositioningModal: false,
                          });
                        }}
                        update={this.loadBranchList}
                      />
                    )}
                  {/* Single DetachablePreview — NEVER remounted regardless of addBranchActive.
                      Prevents emulator restart on form open/close. When flag is on and form
                      is open, the form overlay (.nodeEditPanel) sits to the left at fixed
                      position, and the emulator stays in its native fixed right:0 position.
                      Forced show=true while form is open (see componentDidUpdate). */}
                  <DetachablePreview
                    show={this.state.preview}
                    update={this.handlePreviewUpdate}
                    storyUuid={story.internal_uuid}
                    bookStyle={bookStyleAlias}
                    onClose={this.previewClose}
                    store={storePublicInterface?.internalStore}
                    onPreviewExit={handlePreviewExit}
                    displayAnalyticsOption={isAnalyticsVisible ? 'percentage' : 'hide'}
                    isBranchDetailsCacheDisabled
                    showAnalyticsPanel={isAnalyticsVisible}
                    bookId={story.bookId}
                    episodeId={story.id}
                    scrollToBranch={this.scrollToBranch}
                    onEditStep={this.handleEditStep}
                    reFetchMemoriesTrigger={reFetchMemoriesTrigger}
                    branches={this.state.branch}
                    answerTypes={this.state.answerTypes}
                    modifierTypes={this.state.modifierTypes}
                    addBranchActive={FEATURE_NODE_EDIT_SIDE_PANEL ? this.state.addBranchActive : undefined}
                    cursorBranchId={FEATURE_NODE_EDIT_SIDE_PANEL ? this.state.cursorBranchId : undefined}
                  />
                  {
                    isDuplicateMode
                    && (
                      <Alert
                        className="duplicateBranchsAlert"
                        variant="dark"
                      >
                        <img src={IconCursor} alt="" />
                        click to paste
                      </Alert>
                    )
                  }

                  <HelpSection
                    onDelete={this.handleBranchDelete}
                    show={this.state.HelpPanel}
                    onClose={() => this.setState({ HelpPanel: false })}
                    user={authUser}
                    storyId={this.props.match.params.id}
                    selectedBranches={this.state.branch.filter((branch) => selectionItems.includes(branch.id))}
                    onSharedSettingsUpdate={this.sharedSettingsUpdate}
                    onCopy={this.handleCopy}
                    onPasteIntent={this.handlePasteIntent}
                    disabled={(
                      isDuplicateMode
                      || savePositionLoading
                      || (authUser.role !== 'admin' && this.state.story.story_role === 'viewer')
                      || !this.state.modeEdit
                      || PremiumIpDisabledEdit(authUser.role, this.state.story.book, this.state.story.group)
                      || PremiumIpDisabledApprovedEdit(authUser.role, this.state.story.book)
                      || isLiveEditDisabled(authUser.role, this.state.story.group)
                    )}
                  />
                </PageWrapper>

                {/* Flag off: original Modal overlay. No change.
                    Flag on: form is a fixed overlay panel to the left of the emulator.
                    The emulator (DetachablePreview) stays in its native fixed right:0
                    position and is NEVER remounted — only its `show` prop changes. */}
                {this.addBranch()}
                {this.listLocations()}
                {this.storyNotFound()}
                {this.editBookTags()}

                <SharedSettingsPanel    
                  user={authUser}
                  storyId={this.props.match.params.id}
                  story={this.state.story}
                  selectedItems={selectionItems}
                  show={this.state.sharedSettingsPanel}
                  onHide={this.sharedSettingsPanelHide}
                  update={this.loadBranchList}
                  limits={this.state.limits}
                  onBackgroundsChanged={this.refreshPreviewBackgrounds}
                />

                <ValidatePanel
                  lastEdit={this.state.lastEdit}
                  branch={this.state.branch}
                  storyId={this.props.match.params.id}
                  data={this.state.editBranchData}
                  stepTypes={this.state.stepTypes}
                  show={this.state.validatePanel}
                  onHide={this.validatePanelHide}
                  validateAction={this.validateAction}
                  errCount={this.errCount}
                />

                <InfoPanel
                  lastEdit={this.state.lastEdit}
                  branch={this.state.branch}
                  story={this.state.story}
                  storyId={this.props.match.params.id}
                  data={this.state.editBranchData}
                  stepTypes={this.state.stepTypes}
                  show={this.state.infoPanel}
                  onHide={this.infoPanelHide}
                  validateAction={this.validateAction}
                  isAnalyticsVisible={this.state.isAnalyticsVisible}
                />

                <BranchesListPanel
                  lastEdit={this.state.lastEdit}
                  branch={this.state.branch}
                  story={this.state.story}
                  storyId={this.props.match.params.id}
                  data={this.state.editBranchData}
                  stepTypes={this.state.stepTypes}
                  show={this.state.branchesListPanel}
                  onHide={this.branchesListPanelHide}
                  validateAction={this.validateAction}
                  actionEditBranch={this.revalidateAndOpenBranch}
                  showAnalytics={this.state.isAnalyticsVisible}
                />

                  {this.characters()}

                {this.editCover()}

                {this.state.story?.book && (
                  <PublishModal
                    show={this.state.GoLiveModal}
                    book={this.state.story.book}
                    storyId={this.state.story.id}
                    title={this.livePromptTitle()}
                    isLoading={this.state.GoLiveLoading}
                    publishTypeValue={this.state.story.book.exclusiveAccess ? PublishType.Exclusive : PublishType.General}
                    onConfirm={() => this.updateGoLive()}
                    onCancel={() => this.setState({ GoLiveModal: false })}
                    willAlertShowForNewUser={this.state.story
                      && !(this.state.story.book && !!this.state.story.book.original)
                      && this.state.story.live_count === 0
                      && !authUser.firstPublishData}
                  />
                )}

                <ShareEmulatorLinkModal
                  show={this.state.shareModal}
                  onHide={() => this.setState({ shareModal: false })}
                  linkUrl={linkUrl}
                  storyInternalUuid={this.state.story.internal_uuid}
                />

                <SaveAsTemplate
                  limits={this.state.limits}
                  show={this.state.saveTemplateModal}
                  story={this.state.story}
                  onSuccess={() => {
                    this.loadStory();
                  }}
                  onValidationError={() => {
                    this.setState({
                      saveTemplateModal: false,
                      validatePanel: true,
                    });
                  }}
                  onHide={() => {
                    this.setState({
                      saveTemplateModal: false,
                    });
                    this.loadStory();
                  }}
                />

                {this.renderBookCover()}
                {this.renderChapterRestore()}

                {showMemoryBank && (
                  <MemoryBankModal
                    bookId={story.book.id}
                    bookUsers={story.book.users}
                    onHide={() => {
                      this.setState({
                        showMemoryBank: false,
                        reFetchMemoriesTrigger: reFetchMemoriesTrigger + 1,
                      });
                      memoryBankContext.fetchMemories();
                      memoryIconsContext.fetchMemoryIcons();
                    }}
                  />
                )}

                {showImportTextModal && (
                  <ImportTextModal
                    bookId={story.book.id}
                    episodeId={story.id}
                    onCancel={() => {
                      this.setState({ showImportTextModal: false });
                    }}
                    onSuccess={(nodeId) => {
                      this.setState({
                        lastEdit: nodeId,
                        showImportTextModal: false,
                      });
                      this.updatePreviewAllBranches();
                      this.loadBranchList()
                        .then(() => {
                          this.scrollToBranch(nodeId, true);
                        });
                    }}
                    nodes={nodes}
                  />
                )}

                {showExportTextModal && (
                  <ExportTextModal
                    episodeId={story?.id}
                    onClose={() => {
                      this.setState({ showExportTextModal: false });
                    }}
                  />
                )}

                {showSelectiveEditModal && (
                  <SelectiveEditModal
                    show={showSelectiveEditModal}
                    episodeId={story?.id}
                    bookId={story?.book?.id}
                    preloadedNodes={nodes}
                    memoryBank={memoryBankContext.memories}
                    endpointVersion={this.state.experimentalEpisodeDataFetch}
                    isReadOnly={isLiveEditDisabled(authUser.role, story.group)}
                    initialBranchId={this.state.selectiveEditInitialBranchId}
                    onNavigateToNode={(nodeId) => {
                      this.setState({ showSelectiveEditModal: false, lastEdit: nodeId });
                      this.scrollToBranch(nodeId, true);
                    }}
                    onSave={() => {
                      this.setState({ showSelectiveEditModal: false });
                      this.loadBranchList();
                    }}
                    onHide={() => {
                      this.setState({ showSelectiveEditModal: false });
                    }}
                  />
                )}

                {showPerformanceRanksModal && (
                  <PerformanceRanksContextProvider
                    episodeId={story?.id}
                    episodeTitle={`Episode ${story?.chapter ?? '-'}`}
                  >
                    <PerformanceRanksModal
                      onHide={() => this.setState({
                        showPerformanceRanksModal: false,
                      })}
                      disabled={isLiveEditDisabled(authUser.role, story.group)}
                    />
                  </PerformanceRanksContextProvider>
                )}

                {showExportTextModal && (
                  <ExportTextModal
                    episodeId={story?.id}
                    bookId={story?.book?.id}
                    preloadedNodes={nodes}
                    memoryBank={memoryBankContext.memories}
                    onClose={() => {
                      this.setState({ showExportTextModal: false });
                    }}
                  />
                )}

                {showAchievementsModal && (
                  <AchievementsModal
                    onHide={() => {
                      this.setState({
                        showAchievementsModal: false,
                      });
                    }}
                  />
                )}

                {showHubTagTemplatesModal && (
                  <HubTagTemplatesModal
                    onHide={() => {
                      this.setState({
                        showHubTagTemplatesModal: false,
                      });
                    }}
                  />
                )}
              </CursorProvider>
            </HubTagTemplatesContextProvider>
          </AchievementsContextProvider>
        </VideosProvider>
      </AudiosProvider>
    );
  }
}

export function StoryBranches(props) {
  return (
    <StoryBranchesDorian {...props} />
  );
}
